import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, Teleport as _Teleport, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "tab-action-cb-label",
  title: "Selecionar todas"
}
const _hoisted_2 = ["checked"]
const _hoisted_3 = { class: "tab-action-hint" }
const _hoisted_4 = { class: "tab-action-hint" }
const _hoisted_5 = { class: "group-toolbar-wrap" }
const _hoisted_6 = {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-right":"4px","flex-shrink":"0"}
}
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "group-form-actions" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  class: "filter-wrap",
  ref: "filterRef"
}
const _hoisted_11 = {
  key: 0,
  class: "filter-count-badge"
}
const _hoisted_12 = {
  key: 1,
  class: "filter-dropdown",
  role: "dialog",
  "aria-label": "Filtros do planejamento"
}
const _hoisted_13 = { class: "filter-sheet-head" }
const _hoisted_14 = { class: "filter-sheet-body" }
const _hoisted_15 = { class: "filter-section" }
const _hoisted_16 = { class: "filter-zoom-row" }
const _hoisted_17 = { class: "filter-scale-row" }
const _hoisted_18 = { class: "scale-value" }
const _hoisted_19 = { class: "filter-section" }
const _hoisted_20 = { class: "filter-shortcuts" }
const _hoisted_21 = { class: "filter-dates" }
const _hoisted_22 = { class: "filter-field" }
const _hoisted_23 = { class: "filter-field" }
const _hoisted_24 = { class: "filter-section" }
const _hoisted_25 = { class: "filter-field" }
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 0,
  class: "filter-field"
}
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "filter-check-row" }
const _hoisted_30 = { class: "filter-check-row" }
const _hoisted_31 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  style: {"flex-shrink":"0"}
}
const _hoisted_32 = { class: "filter-sheet-foot" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  fill: "none",
  style: {"margin-right":"5px","flex-shrink":"0"}
}
const _hoisted_35 = {
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  fill: "none",
  style: {"margin-right":"5px","flex-shrink":"0"}
}
const _hoisted_36 = { class: "planning-content" }
const _hoisted_37 = {
  key: 0,
  class: "planning-topbar"
}
const _hoisted_38 = { class: "topbar-search" }
const _hoisted_39 = { class: "status-chips" }
const _hoisted_40 = { class: "chip-count" }
const _hoisted_41 = { class: "chip-count" }
const _hoisted_42 = { class: "chip-count" }
const _hoisted_43 = { class: "chip-count" }
const _hoisted_44 = { class: "chip-count" }
const _hoisted_45 = { class: "chip-count" }
const _hoisted_46 = {
  class: "topbar-overall",
  title: "Progresso médio de todas as tarefas"
}
const _hoisted_47 = { class: "topbar-overall-track" }
const _hoisted_48 = { class: "topbar-overall-pct" }
const _hoisted_49 = {
  key: 1,
  class: "gantt-skeleton"
}
const _hoisted_50 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_51 = {
  key: 3,
  class: "planning-body"
}
const _hoisted_52 = { class: "label-header" }
const _hoisted_53 = ["checked"]
const _hoisted_54 = { class: "label-header-actions" }
const _hoisted_55 = {
  key: 1,
  class: "label-header-progress"
}
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["checked", "onChange"]
const _hoisted_58 = ["title"]
const _hoisted_59 = { class: "label-meta" }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = {
  key: 1,
  class: "label-progress-wrap"
}
const _hoisted_62 = { class: "label-progress-track" }
const _hoisted_63 = { class: "label-progress-pct" }
const _hoisted_64 = {
  class: "header-groups",
  style: { height: '26px' }
}
const _hoisted_65 = {
  class: "header-days",
  style: { height: '26px' }
}
const _hoisted_66 = ["onMousedown", "onClick"]
const _hoisted_67 = { class: "bar-center-pct" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["d"]
const _hoisted_70 = {
  key: 4,
  class: "undated-section"
}
const _hoisted_71 = { class: "undated-count" }
const _hoisted_72 = {
  key: 0,
  class: "undated-list"
}
const _hoisted_73 = ["onClick"]
const _hoisted_74 = ["checked", "onChange"]
const _hoisted_75 = { class: "undated-info" }
const _hoisted_76 = ["title"]
const _hoisted_77 = { class: "undated-meta" }
const _hoisted_78 = { class: "undated-progress" }
const _hoisted_79 = { class: "undated-progress-track" }
const _hoisted_80 = { class: "undated-progress-pct" }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "panel-header" }
const _hoisted_83 = ["title"]
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { class: "panel-body" }
const _hoisted_87 = { class: "panel-info" }
const _hoisted_88 = { class: "info-row" }
const _hoisted_89 = {
  key: 0,
  class: "info-row"
}
const _hoisted_90 = { class: "info-row" }
const _hoisted_91 = { class: "info-row" }
const _hoisted_92 = { class: "info-row" }
const _hoisted_93 = { class: "info-row" }
const _hoisted_94 = {
  key: 2,
  class: "info-row info-row--block"
}
const _hoisted_95 = { class: "info-description" }
const _hoisted_96 = {
  key: 3,
  class: "info-row info-row--block"
}
const _hoisted_97 = { class: "info-dep-tags" }
const _hoisted_98 = {
  key: 4,
  class: "info-row info-row--block"
}
const _hoisted_99 = { class: "info-description" }
const _hoisted_100 = {
  key: 5,
  class: "info-row info-row--block"
}
const _hoisted_101 = { class: "info-tool-section" }
const _hoisted_102 = { class: "info-tool-tag" }
const _hoisted_103 = {
  key: 6,
  class: "info-row info-row--block"
}
const _hoisted_104 = { class: "info-machinery-section" }
const _hoisted_105 = { class: "info-machinery-tag" }
const _hoisted_106 = {
  key: 7,
  class: "info-row info-row--block"
}
const _hoisted_107 = { class: "info-team-tags" }
const _hoisted_108 = { class: "panel-track" }
const _hoisted_109 = { class: "panel-progress-bar" }
const _hoisted_110 = { class: "panel-actions" }
const _hoisted_111 = {
  key: 0,
  class: "progress-history"
}
const _hoisted_112 = { class: "progress-history-head" }
const _hoisted_113 = ["onClick"]
const _hoisted_114 = { class: "progress-history-pct" }
const _hoisted_115 = { class: "progress-history-date" }
const _hoisted_116 = { class: "progress-history-badges" }
const _hoisted_117 = {
  key: 0,
  class: "progress-badge-icon",
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_118 = {
  key: 1,
  class: "progress-badge-icon",
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_119 = {
  key: 0,
  class: "progress-history-chevron",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_120 = ["onClick"]
const _hoisted_121 = {
  key: 0,
  class: "progress-history-detail"
}
const _hoisted_122 = {
  key: 0,
  class: "progress-detail-note"
}
const _hoisted_123 = ["src", "onClick"]
const _hoisted_124 = { class: "comments-section" }
const _hoisted_125 = { class: "progress-history-title" }
const _hoisted_126 = { class: "comments-count" }
const _hoisted_127 = {
  key: 0,
  class: "comments-loading"
}
const _hoisted_128 = {
  key: 1,
  class: "comments-empty"
}
const _hoisted_129 = {
  key: 2,
  class: "comments-list"
}
const _hoisted_130 = ["src"]
const _hoisted_131 = { key: 1 }
const _hoisted_132 = { class: "comment-body" }
const _hoisted_133 = { class: "comment-meta" }
const _hoisted_134 = { class: "comment-author" }
const _hoisted_135 = { class: "comment-date" }
const _hoisted_136 = { class: "comment-text" }
const _hoisted_137 = ["onClick"]
const _hoisted_138 = { class: "comment-input-row" }
const _hoisted_139 = ["disabled"]
const _hoisted_140 = { class: "form-grid" }
const _hoisted_141 = { class: "input-field" }
const _hoisted_142 = { class: "input-field" }
const _hoisted_143 = { class: "input-field" }
const _hoisted_144 = { class: "input-field full-width" }
const _hoisted_145 = ["src"]
const _hoisted_146 = {
  key: 1,
  class: "photo-upload-hint"
}
const _hoisted_147 = { class: "panel-actions" }
const _hoisted_148 = { class: "form-grid" }
const _hoisted_149 = { class: "input-field" }
const _hoisted_150 = { class: "input-field" }
const _hoisted_151 = { class: "input-field" }
const _hoisted_152 = ["value"]
const _hoisted_153 = { class: "input-field" }
const _hoisted_154 = { class: "input-field" }
const _hoisted_155 = { class: "color-picker-wrap" }
const _hoisted_156 = {
  key: 0,
  class: "recent-colors"
}
const _hoisted_157 = ["title", "onClick"]
const _hoisted_158 = { class: "input-field" }
const _hoisted_159 = ["disabled"]
const _hoisted_160 = { class: "nodate-check" }
const _hoisted_161 = {
  key: 0,
  class: "nodate-hint"
}
const _hoisted_162 = { class: "input-field" }
const _hoisted_163 = { class: "workdays-row" }
const _hoisted_164 = ["value"]
const _hoisted_165 = { class: "input-field" }
const _hoisted_166 = { class: "dep-combo" }
const _hoisted_167 = {
  key: 0,
  class: "dep-tags"
}
const _hoisted_168 = ["onClick"]
const _hoisted_169 = { class: "dep-search-wrap" }
const _hoisted_170 = {
  key: 0,
  class: "dep-search-dropdown"
}
const _hoisted_171 = ["onMousedown"]
const _hoisted_172 = {
  key: 1,
  class: "dep-search-dropdown"
}
const _hoisted_173 = { class: "input-field full-width" }
const _hoisted_174 = { class: "tool-combo" }
const _hoisted_175 = {
  key: 0,
  class: "tool-tags"
}
const _hoisted_176 = ["onClick"]
const _hoisted_177 = { class: "tool-search-wrap" }
const _hoisted_178 = {
  key: 0,
  class: "tool-search-dropdown"
}
const _hoisted_179 = ["onMousedown"]
const _hoisted_180 = { class: "tool-operational" }
const _hoisted_181 = {
  key: 1,
  class: "tool-search-dropdown"
}
const _hoisted_182 = {
  key: 1,
  class: "tool-quantity-input-wrap"
}
const _hoisted_183 = { class: "input-field full-width" }
const _hoisted_184 = { class: "input-field full-width" }
const _hoisted_185 = { class: "file-combo" }
const _hoisted_186 = {
  key: 0,
  class: "file-tags"
}
const _hoisted_187 = ["onClick"]
const _hoisted_188 = { class: "file-search-wrap" }
const _hoisted_189 = {
  key: 0,
  class: "file-search-dropdown"
}
const _hoisted_190 = ["onMousedown"]
const _hoisted_191 = {
  key: 1,
  class: "file-search-dropdown"
}
const _hoisted_192 = { class: "input-field full-width" }
const _hoisted_193 = { class: "team-combo" }
const _hoisted_194 = {
  key: 0,
  class: "team-tags"
}
const _hoisted_195 = ["onClick"]
const _hoisted_196 = { class: "team-search-wrap" }
const _hoisted_197 = {
  key: 0,
  class: "team-search-dropdown"
}
const _hoisted_198 = ["onMousedown"]
const _hoisted_199 = {
  key: 1,
  class: "team-search-dropdown"
}
const _hoisted_200 = { class: "input-field full-width" }
const _hoisted_201 = {
  key: 0,
  class: "machinery-tags"
}
const _hoisted_202 = ["onClick"]
const _hoisted_203 = { class: "machinery-search-wrap" }
const _hoisted_204 = {
  key: 0,
  class: "machinery-search-dropdown"
}
const _hoisted_205 = ["onMousedown"]
const _hoisted_206 = { class: "machinery-category" }
const _hoisted_207 = {
  key: 1,
  class: "machinery-search-dropdown"
}
const _hoisted_208 = {
  key: 0,
  class: "edit-error"
}
const _hoisted_209 = { class: "panel-actions" }
const _hoisted_210 = { class: "form-grid" }
const _hoisted_211 = { class: "input-field" }
const _hoisted_212 = { class: "input-field" }
const _hoisted_213 = { class: "input-field" }
const _hoisted_214 = ["value"]
const _hoisted_215 = { class: "input-field" }
const _hoisted_216 = { class: "input-field" }
const _hoisted_217 = { class: "color-picker-wrap" }
const _hoisted_218 = {
  key: 0,
  class: "recent-colors"
}
const _hoisted_219 = ["title", "onClick"]
const _hoisted_220 = { class: "input-field" }
const _hoisted_221 = ["disabled"]
const _hoisted_222 = { class: "nodate-check" }
const _hoisted_223 = {
  key: 0,
  class: "nodate-hint"
}
const _hoisted_224 = { class: "input-field" }
const _hoisted_225 = { class: "workdays-row" }
const _hoisted_226 = ["value"]
const _hoisted_227 = {
  key: 0,
  class: "input-field"
}
const _hoisted_228 = { class: "dep-combo" }
const _hoisted_229 = {
  key: 0,
  class: "dep-tags"
}
const _hoisted_230 = ["onClick"]
const _hoisted_231 = { class: "dep-search-wrap" }
const _hoisted_232 = {
  key: 0,
  class: "dep-search-dropdown"
}
const _hoisted_233 = ["onMousedown"]
const _hoisted_234 = {
  key: 1,
  class: "dep-search-dropdown"
}
const _hoisted_235 = { class: "input-field full-width" }
const _hoisted_236 = { class: "tool-combo" }
const _hoisted_237 = {
  key: 0,
  class: "tool-tags"
}
const _hoisted_238 = ["onClick"]
const _hoisted_239 = { class: "tool-search-wrap" }
const _hoisted_240 = {
  key: 0,
  class: "tool-search-dropdown"
}
const _hoisted_241 = ["onMousedown"]
const _hoisted_242 = { class: "tool-operational" }
const _hoisted_243 = {
  key: 1,
  class: "tool-search-dropdown"
}
const _hoisted_244 = {
  key: 1,
  class: "tool-quantity-input-wrap"
}
const _hoisted_245 = { class: "input-field full-width" }
const _hoisted_246 = { class: "input-field full-width" }
const _hoisted_247 = { class: "file-combo" }
const _hoisted_248 = {
  key: 0,
  class: "file-tags"
}
const _hoisted_249 = ["onClick"]
const _hoisted_250 = { class: "file-search-wrap" }
const _hoisted_251 = {
  key: 0,
  class: "file-search-dropdown"
}
const _hoisted_252 = ["onMousedown"]
const _hoisted_253 = {
  key: 1,
  class: "file-search-dropdown"
}
const _hoisted_254 = { class: "input-field full-width" }
const _hoisted_255 = { class: "team-combo" }
const _hoisted_256 = {
  key: 0,
  class: "team-tags"
}
const _hoisted_257 = ["onClick"]
const _hoisted_258 = { class: "team-search-wrap" }
const _hoisted_259 = {
  key: 0,
  class: "team-search-dropdown"
}
const _hoisted_260 = ["onMousedown"]
const _hoisted_261 = {
  key: 1,
  class: "team-search-dropdown"
}
const _hoisted_262 = { class: "input-field full-width" }
const _hoisted_263 = {
  key: 0,
  class: "machinery-tags"
}
const _hoisted_264 = ["onClick"]
const _hoisted_265 = { class: "machinery-search-wrap" }
const _hoisted_266 = {
  key: 0,
  class: "machinery-search-dropdown"
}
const _hoisted_267 = ["onMousedown"]
const _hoisted_268 = { class: "machinery-category" }
const _hoisted_269 = {
  key: 1,
  class: "machinery-search-dropdown"
}
const _hoisted_270 = {
  key: 0,
  class: "edit-error"
}
const _hoisted_271 = { class: "panel-actions" }
const _hoisted_272 = { class: "import-modal" }
const _hoisted_273 = { class: "import-modal-head" }
const _hoisted_274 = { class: "import-upload-card" }
const _hoisted_275 = { class: "import-upload-actions" }
const _hoisted_276 = {
  key: 0,
  class: "import-error"
}
const _hoisted_277 = {
  key: 1,
  class: "import-review"
}
const _hoisted_278 = { class: "import-review-head" }
const _hoisted_279 = { class: "import-table-wrap" }
const _hoisted_280 = { class: "import-table" }
const _hoisted_281 = ["onUpdate:modelValue"]
const _hoisted_282 = ["onUpdate:modelValue"]
const _hoisted_283 = ["onUpdate:modelValue"]
const _hoisted_284 = ["onUpdate:modelValue"]
const _hoisted_285 = ["onUpdate:modelValue"]
const _hoisted_286 = {
  key: 1,
  class: "import-color-chip"
}
const _hoisted_287 = ["onUpdate:modelValue"]
const _hoisted_288 = ["value"]
const _hoisted_289 = { class: "import-actions-col" }
const _hoisted_290 = ["onClick"]
const _hoisted_291 = {
  key: 0,
  class: "import-advanced-row"
}
const _hoisted_292 = { colspan: "7" }
const _hoisted_293 = { class: "import-advanced-grid" }
const _hoisted_294 = { class: "input-field" }
const _hoisted_295 = { class: "workdays-row" }
const _hoisted_296 = ["checked", "onChange"]
const _hoisted_297 = { class: "input-field" }
const _hoisted_298 = ["onUpdate:modelValue"]
const _hoisted_299 = ["value"]
const _hoisted_300 = { class: "input-field" }
const _hoisted_301 = ["onUpdate:modelValue"]
const _hoisted_302 = { class: "input-field" }
const _hoisted_303 = ["onUpdate:modelValue"]
const _hoisted_304 = ["value"]
const _hoisted_305 = { class: "input-field" }
const _hoisted_306 = ["onUpdate:modelValue"]
const _hoisted_307 = ["value"]
const _hoisted_308 = { class: "input-field" }
const _hoisted_309 = { class: "import-inline-row" }
const _hoisted_310 = ["onUpdate:modelValue"]
const _hoisted_311 = ["value"]
const _hoisted_312 = ["onUpdate:modelValue"]
const _hoisted_313 = ["onClick"]
const _hoisted_314 = {
  key: 0,
  class: "import-tag-list"
}
const _hoisted_315 = ["onUpdate:modelValue"]
const _hoisted_316 = ["onClick"]
const _hoisted_317 = { class: "input-field" }
const _hoisted_318 = { class: "import-inline-row" }
const _hoisted_319 = ["onUpdate:modelValue"]
const _hoisted_320 = ["value"]
const _hoisted_321 = ["onUpdate:modelValue"]
const _hoisted_322 = ["onClick"]
const _hoisted_323 = {
  key: 0,
  class: "import-tag-list"
}
const _hoisted_324 = ["onUpdate:modelValue"]
const _hoisted_325 = ["onClick"]
const _hoisted_326 = { class: "modal-footer" }
const _hoisted_327 = ["disabled"]
const _hoisted_328 = { class: "modal-card" }
const _hoisted_329 = { class: "modal-header" }
const _hoisted_330 = { class: "blocked-add-row" }
const _hoisted_331 = { class: "blocked-list" }
const _hoisted_332 = {
  key: 0,
  class: "hint"
}
const _hoisted_333 = ["onClick"]
const _hoisted_334 = { class: "modal-footer" }
const _hoisted_335 = ["src"]
const _hoisted_336 = { class: "report-modal" }
const _hoisted_337 = { class: "report-modal-header" }
const _hoisted_338 = { class: "report-modal-title" }
const _hoisted_339 = {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  style: {"flex-shrink":"0"}
}
const _hoisted_340 = { class: "report-modal-controls" }
const _hoisted_341 = {
  key: 0,
  class: "report-week-nav"
}
const _hoisted_342 = { class: "report-week-label" }
const _hoisted_343 = ["disabled"]
const _hoisted_344 = {
  key: 1,
  class: "report-week-label report-week-label--nodate"
}
const _hoisted_345 = { class: "report-range-row" }
const _hoisted_346 = ["disabled"]
const _hoisted_347 = {
  key: 1,
  class: "report-range-hint"
}
const _hoisted_348 = {
  key: 0,
  class: "report-loading"
}
const _hoisted_349 = {
  key: 1,
  class: "report-error"
}
const _hoisted_350 = {
  key: 2,
  class: "report-body"
}
const _hoisted_351 = { class: "report-summary-row" }
const _hoisted_352 = { class: "report-chip report-chip--total" }
const _hoisted_353 = { class: "report-chip report-chip--done" }
const _hoisted_354 = {
  key: 0,
  class: "report-chip report-chip--late"
}
const _hoisted_355 = {
  key: 1,
  class: "report-chip report-chip--pending"
}
const _hoisted_356 = {
  key: 2,
  class: "report-chip report-chip--nodate"
}
const _hoisted_357 = { class: "report-section-title" }
const _hoisted_358 = {
  key: 0,
  class: "report-empty"
}
const _hoisted_359 = { class: "report-task-header" }
const _hoisted_360 = { class: "report-task-left" }
const _hoisted_361 = { class: "report-task-name" }
const _hoisted_362 = {
  key: 0,
  class: "report-task-group"
}
const _hoisted_363 = { class: "report-task-right" }
const _hoisted_364 = {
  key: 0,
  class: "report-task-dates report-task-dates--nodate"
}
const _hoisted_365 = {
  key: 1,
  class: "report-task-dates"
}
const _hoisted_366 = { class: "report-progress-bar" }
const _hoisted_367 = {
  key: 0,
  class: "report-updates"
}
const _hoisted_368 = { class: "report-update-meta" }
const _hoisted_369 = {
  key: 0,
  class: "report-update-note"
}
const _hoisted_370 = ["src", "onClick"]
const _hoisted_371 = { class: "report-upcoming-name" }
const _hoisted_372 = { class: "report-upcoming-date" }
const _hoisted_373 = { class: "report-print-row" }
const _hoisted_374 = ["disabled"]
const _hoisted_375 = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_376 = {
  key: 1,
  class: "report-spinner",
  style: {"width":"13px","height":"13px","border-width":"1.5px","margin-right":"6px"}
}
const _hoisted_377 = {
  key: 0,
  class: "gantt-print-overlay"
}
const _hoisted_378 = { class: "share-modal" }
const _hoisted_379 = { class: "share-modal-header" }
const _hoisted_380 = { class: "share-modal-title" }
const _hoisted_381 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  style: {"flex-shrink":"0"}
}
const _hoisted_382 = { class: "share-section" }
const _hoisted_383 = { class: "share-action-row" }
const _hoisted_384 = { class: "share-section" }
const _hoisted_385 = { class: "share-action-row" }
const _hoisted_386 = {
  key: 0,
  class: "share-section share-section--manage"
}
const _hoisted_387 = { class: "share-modal share-modal--sm" }
const _hoisted_388 = { class: "share-modal-header" }
const _hoisted_389 = { class: "share-modal-title" }
const _hoisted_390 = { class: "share-section" }
const _hoisted_391 = {
  key: 0,
  class: "input-field",
  style: {"margin-bottom":"14px"}
}
const _hoisted_392 = { class: "duration-presets" }
const _hoisted_393 = ["onClick"]
const _hoisted_394 = { class: "share-modal-footer" }
const _hoisted_395 = ["disabled"]
const _hoisted_396 = {
  key: 0,
  class: "share-error"
}
const _hoisted_397 = { class: "share-modal share-modal--sm" }
const _hoisted_398 = { class: "share-modal-header" }
const _hoisted_399 = { class: "share-section" }
const _hoisted_400 = { class: "share-link-row" }
const _hoisted_401 = ["value"]
const _hoisted_402 = {
  key: 0,
  class: "share-expiry-note"
}
const _hoisted_403 = { class: "share-modal-footer" }
const _hoisted_404 = { class: "share-modal share-modal--lg" }
const _hoisted_405 = { class: "share-modal-header" }
const _hoisted_406 = { class: "manage-list" }
const _hoisted_407 = {
  key: 0,
  class: "manage-empty"
}
const _hoisted_408 = { class: "manage-item-info" }
const _hoisted_409 = { class: "manage-item-hash" }
const _hoisted_410 = {
  key: 0,
  class: "manage-chip manage-chip--email"
}
const _hoisted_411 = {
  key: 1,
  class: "manage-chip"
}
const _hoisted_412 = { class: "manage-hash-code" }
const _hoisted_413 = { class: "manage-item-meta" }
const _hoisted_414 = {
  key: 0,
  class: "manage-status manage-status--revoked"
}
const _hoisted_415 = {
  key: 1,
  class: "manage-status manage-status--expired"
}
const _hoisted_416 = {
  key: 2,
  class: "manage-status manage-status--active"
}
const _hoisted_417 = {
  key: 3,
  class: "manage-status manage-status--active"
}
const _hoisted_418 = {
  key: 0,
  class: "manage-item-actions"
}
const _hoisted_419 = ["onClick"]
const _hoisted_420 = ["onClick"]
const _hoisted_421 = ["onClick"]
const _hoisted_422 = { class: "share-modal-footer" }
const _hoisted_423 = { class: "share-modal share-modal--sm" }
const _hoisted_424 = { class: "share-modal-header" }
const _hoisted_425 = { class: "share-section" }
const _hoisted_426 = { class: "duration-presets" }
const _hoisted_427 = ["onClick"]
const _hoisted_428 = { class: "share-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonBlock = _resolveComponent("SkeletonBlock")!
  const _component_SubmissionPrintPreview = _resolveComponent("SubmissionPrintPreview")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "planning-shell",
      onMousemovePassive: _cache[146] || (_cache[146] = 
//@ts-ignore
(...args) => (_ctx.onMouseMove && _ctx.onMouseMove(...args))),
      onMouseup: _cache[147] || (_cache[147] = 
//@ts-ignore
(...args) => (_ctx.onMouseUp && _ctx.onMouseUp(...args))),
      onMouseleave: _cache[148] || (_cache[148] = 
//@ts-ignore
(...args) => (_ctx.onMouseUp && _ctx.onMouseUp(...args))),
      onTouchmovePassive: _cache[149] || (_cache[149] = 
//@ts-ignore
(...args) => (_ctx.onTouchMove && _ctx.onTouchMove(...args))),
      onTouchend: _cache[150] || (_cache[150] = 
//@ts-ignore
(...args) => (_ctx.onTouchEnd && _ctx.onTouchEnd(...args)))
    }, [
      (_openBlock(), _createBlock(_Teleport, { to: "#gantt-toolbar-slot" }, [
        (_ctx.ganttEditMode)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("label", _hoisted_1, [
                _createElementVNode("input", {
                  ref: "selectAllEl",
                  type: "checkbox",
                  class: "tab-action-cb",
                  checked: _ctx.isAllSelected,
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)))
                }, null, 40, _hoisted_2)
              ]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.selectedGanttIds.size) + " sel.", 1),
              (_ctx.selectedGanttIds.size > 0 && _ctx.onDeleteTask && !_ctx.isAnalyst)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "tab-action-btn tab-action-btn--danger",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteSelected && _ctx.deleteSelected(...args)))
                  }, " Apagar "))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "tab-action-btn",
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelEditMode && _ctx.cancelEditMode(...args)))
              }, "Cancelar")
            ], 64))
          : (_ctx.selectedGanttIds.size > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.selectedGanttIds.size) + " sel.", 1),
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.accessMode === 'edit' && !_ctx.isAnalyst && _ctx.onSaveGroup)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "tab-action-btn tab-action-btn--group",
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showGroupForm = !_ctx.showGroupForm))
                      }, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[189] || (_cache[189] = [
                          _createElementVNode("rect", {
                            x: "3",
                            y: "3",
                            width: "7",
                            height: "7"
                          }, null, -1),
                          _createElementVNode("rect", {
                            x: "14",
                            y: "3",
                            width: "7",
                            height: "7"
                          }, null, -1),
                          _createElementVNode("rect", {
                            x: "3",
                            y: "14",
                            width: "7",
                            height: "7"
                          }, null, -1),
                          _createElementVNode("path", { d: "M14 17h7M17 14v7" }, null, -1)
                        ]))])),
                        _cache[190] || (_cache[190] = _createTextVNode(" Agrupar ", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showGroupForm)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "group-form-popover",
                        onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _cache[192] || (_cache[192] = _createElementVNode("div", { class: "group-form-title" }, "Criar grupo", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.groupForm.name) = $event)),
                          class: "group-form-input",
                          placeholder: "Nome do grupo (ex: Fundação)",
                          autofocus: "",
                          onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.saveGroup && _ctx.saveGroup(...args)), ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.groupForm.name]
                        ]),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.groupForm.responsibleUsername) = $event)),
                          class: "group-form-input"
                        }, [
                          _cache[191] || (_cache[191] = _createElementVNode("option", { value: "" }, "Sem responsável", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assignableUsers, (u) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: u.username,
                              value: u.username
                            }, _toDisplayString(u.name), 9, _hoisted_7))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.groupForm.responsibleUsername]
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("button", {
                            class: "group-form-btn group-form-btn--primary",
                            type: "button",
                            disabled: !_ctx.groupForm.name.trim() || _ctx.groupSaving,
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveGroup && _ctx.saveGroup(...args)))
                          }, _toDisplayString(_ctx.groupSaving ? 'Salvando…' : 'Criar grupo'), 9, _hoisted_9),
                          _createElementVNode("button", {
                            class: "group-form-btn",
                            type: "button",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showGroupForm = false))
                          }, "Cancelar")
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.selectedGanttIds.size > 0 && _ctx.onDeleteTask && !_ctx.isAnalyst)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "tab-action-btn tab-action-btn--danger",
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.deleteSelected && _ctx.deleteSelected(...args)))
                    }, "Apagar"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "tab-action-btn",
                  type: "button",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.clearSelection && _ctx.clearSelection(...args)))
                }, "Cancelar")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["tab-action-btn", { active: _ctx.showFilters }]),
                    type: "button",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showFilters = !_ctx.showFilters))
                  }, [
                    _cache[193] || (_cache[193] = _createTextVNode(" Filtros", -1)),
                    (_ctx.activeFilterCount > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.activeFilterCount), 1))
                      : _createCommentVNode("", true)
                  ], 2),
                  (_ctx.showFilters)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "filter-backdrop",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showFilters = false))
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.showFilters)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _cache[209] || (_cache[209] = _createElementVNode("div", {
                          class: "filter-sheet-grip",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_13, [
                          _cache[194] || (_cache[194] = _createElementVNode("span", { class: "filter-sheet-title" }, "Filtros", -1)),
                          _createElementVNode("button", {
                            class: "filter-sheet-close",
                            type: "button",
                            "aria-label": "Fechar filtros",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showFilters = false))
                          }, "✕")
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _cache[195] || (_cache[195] = _createElementVNode("span", { class: "filter-section-label" }, "Visualização", -1)),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["zoom-btn", { active: _ctx.zoom === 'day' }]),
                                type: "button",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setZoom('day')))
                              }, "Dia", 2),
                              _createElementVNode("button", {
                                class: _normalizeClass(["zoom-btn", { active: _ctx.zoom === 'week' }]),
                                type: "button",
                                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setZoom('week')))
                              }, "Semana", 2),
                              _createElementVNode("button", {
                                class: _normalizeClass(["zoom-btn", { active: _ctx.zoom === 'month' }]),
                                type: "button",
                                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setZoom('month')))
                              }, "Mês", 2),
                              _createElementVNode("button", {
                                class: "zoom-btn",
                                type: "button",
                                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.scrollToToday && _ctx.scrollToToday(...args)))
                              }, "Hoje")
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _withDirectives(_createElementVNode("input", {
                                type: "range",
                                min: "25",
                                max: "350",
                                step: "5",
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.zoomScale) = $event)),
                                class: "scale-slider"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.zoomScale,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.zoomScale) + "%", 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _cache[198] || (_cache[198] = _createElementVNode("span", { class: "filter-section-label" }, "Período", -1)),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("button", {
                                class: "filter-chip",
                                type: "button",
                                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.applyThisWeek && _ctx.applyThisWeek(...args)))
                              }, "Essa semana"),
                              _createElementVNode("button", {
                                class: "filter-chip",
                                type: "button",
                                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.applyNextWeek && _ctx.applyNextWeek(...args)))
                              }, "Próx. semana"),
                              _createElementVNode("button", {
                                class: "filter-chip",
                                type: "button",
                                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.applyLast2Weeks && _ctx.applyLast2Weeks(...args)))
                              }, "Últ. 2 semanas"),
                              _createElementVNode("button", {
                                class: "filter-chip",
                                type: "button",
                                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.applyLastMonth && _ctx.applyLastMonth(...args)))
                              }, "Último mês")
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _cache[196] || (_cache[196] = _createElementVNode("label", null, "De", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.filters.dateFrom) = $event)),
                                  type: "date",
                                  class: "filter-input"
                                }, null, 512), [
                                  [_vModelText, _ctx.filters.dateFrom]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _cache[197] || (_cache[197] = _createElementVNode("label", null, "Até", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.filters.dateTo) = $event)),
                                  type: "date",
                                  class: "filter-input"
                                }, null, 512), [
                                  [_vModelText, _ctx.filters.dateTo]
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _cache[205] || (_cache[205] = _createElementVNode("span", { class: "filter-section-label" }, "Filtrar por", -1)),
                            _createElementVNode("div", _hoisted_25, [
                              _cache[200] || (_cache[200] = _createElementVNode("label", null, "Responsável", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.filters.assignee) = $event)),
                                class: "filter-input"
                              }, [
                                _cache[199] || (_cache[199] = _createElementVNode("option", { value: "" }, "Todos", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assigneeOptions, (u) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: u,
                                    value: u
                                  }, _toDisplayString(u), 9, _hoisted_26))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.filters.assignee]
                              ])
                            ]),
                            (_ctx.groups.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _cache[202] || (_cache[202] = _createElementVNode("label", null, "Grupo", -1)),
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.filters.groupId) = $event)),
                                    class: "filter-input"
                                  }, [
                                    _cache[201] || (_cache[201] = _createElementVNode("option", { value: "" }, "Todos", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (g) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: g.id,
                                        value: g.id
                                      }, _toDisplayString(g.name), 9, _hoisted_28))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _ctx.filters.groupId]
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("label", _hoisted_29, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.filters.hideCompleted) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.filters.hideCompleted]
                              ]),
                              _cache[203] || (_cache[203] = _createElementVNode("span", null, "Ocultar concluídas", -1))
                            ]),
                            _createElementVNode("label", _hoisted_30, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.filters.showOverdue) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.filters.showOverdue]
                              ]),
                              _cache[204] || (_cache[204] = _createElementVNode("span", null, "Mostrar atrasadas", -1))
                            ])
                          ]),
                          (_ctx.accessMode === 'edit' && !_ctx.isAnalyst)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[208] || (_cache[208] = _createElementVNode("div", { class: "filter-divider" }, null, -1)),
                                _createElementVNode("button", {
                                  class: "toolbar-btn filter-import-btn",
                                  type: "button",
                                  onClick: _cache[30] || (_cache[30] = ($event: any) => {_ctx.openImportModal(); _ctx.showFilters = false})
                                }, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_31, [...(_cache[206] || (_cache[206] = [
                                    _createElementVNode("path", {
                                      d: "M7 1v8M4 6l3 3 3-3M2 11h10",
                                      stroke: "currentColor",
                                      "stroke-width": "1.4",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, null, -1)
                                  ]))])),
                                  _cache[207] || (_cache[207] = _createTextVNode(" Importar tarefas ", -1))
                                ])
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("button", {
                            class: "filter-foot-btn",
                            type: "button",
                            disabled: _ctx.activeFilterCount === 0,
                            onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
                          }, "Limpar", 8, _hoisted_33),
                          _createElementVNode("button", {
                            class: "filter-foot-btn filter-foot-btn--primary",
                            type: "button",
                            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.showFilters = false))
                          }, " Ver " + _toDisplayString(_ctx.filteredRows.length + _ctx.undatedRows.length) + " tarefa" + _toDisplayString((_ctx.filteredRows.length + _ctx.undatedRows.length) === 1 ? '' : 's'), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 512),
                _createElementVNode("button", {
                  class: "tab-action-btn tab-action-btn--share",
                  type: "button",
                  onClick: _cache[33] || (_cache[33] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openShareModal && _ctx.openShareModal(...args)), ["stop"]))
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_34, [...(_cache[210] || (_cache[210] = [
                    _createElementVNode("circle", {
                      cx: "10.5",
                      cy: "2.5",
                      r: "1.8",
                      stroke: "currentColor",
                      "stroke-width": "1.3"
                    }, null, -1),
                    _createElementVNode("circle", {
                      cx: "10.5",
                      cy: "10.5",
                      r: "1.8",
                      stroke: "currentColor",
                      "stroke-width": "1.3"
                    }, null, -1),
                    _createElementVNode("circle", {
                      cx: "2.5",
                      cy: "6.5",
                      r: "1.8",
                      stroke: "currentColor",
                      "stroke-width": "1.3"
                    }, null, -1),
                    _createElementVNode("path", {
                      d: "M4.2 5.6l4.6-2.3M4.2 7.4l4.6 2.3",
                      stroke: "currentColor",
                      "stroke-width": "1.3",
                      "stroke-linecap": "round"
                    }, null, -1)
                  ]))])),
                  _cache[211] || (_cache[211] = _createTextVNode(" Compartilhar ", -1))
                ]),
                (_ctx.projectId)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "tab-action-btn tab-action-btn--report",
                      type: "button",
                      onClick: _cache[34] || (_cache[34] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openGanttReport && _ctx.openGanttReport(...args)), ["stop"]))
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_35, [...(_cache[212] || (_cache[212] = [
                        _createElementVNode("rect", {
                          x: "2",
                          y: "1.5",
                          width: "9",
                          height: "10",
                          rx: "1.2",
                          stroke: "currentColor",
                          "stroke-width": "1.3"
                        }, null, -1),
                        _createElementVNode("path", {
                          d: "M4 4.5h5M4 6.5h5M4 8.5h3",
                          stroke: "currentColor",
                          "stroke-width": "1.2",
                          "stroke-linecap": "round"
                        }, null, -1)
                      ]))])),
                      _cache[213] || (_cache[213] = _createTextVNode(" Relatório ", -1))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
      ])),
      _createElementVNode("div", {
        class: _normalizeClass(["planning-row", { 'has-panel': _ctx.showPanel }])
      }, [
        _createElementVNode("div", _hoisted_36, [
          (_ctx.rows.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _cache[214] || (_cache[214] = _createElementVNode("svg", {
                    class: "topbar-search-icon",
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round"
                  }, [
                    _createElementVNode("circle", {
                      cx: "11",
                      cy: "11",
                      r: "7"
                    }),
                    _createElementVNode("path", { d: "M21 21l-4.3-4.3" })
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.filters.search) = $event)),
                    type: "text",
                    class: "topbar-search-input",
                    placeholder: "Buscar tarefa..."
                  }, null, 512), [
                    [_vModelText, _ctx.filters.search]
                  ]),
                  (_ctx.filters.search)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "topbar-search-clear",
                        type: "button",
                        title: "Limpar busca",
                        onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.filters.search = ''))
                      }, "✕"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["status-chip", { active: _ctx.filters.status === '' }]),
                    type: "button",
                    onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.filters.status = ''))
                  }, [
                    _cache[215] || (_cache[215] = _createTextVNode(" Todas ", -1)),
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.statusCounts.total), 1)
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["status-chip status-chip--idle", { active: _ctx.filters.status === 'idle' }]),
                    type: "button",
                    onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.setStatusFilter('idle')))
                  }, [
                    _cache[216] || (_cache[216] = _createTextVNode(" Não iniciadas ", -1)),
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.statusCounts.idle), 1)
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["status-chip status-chip--progress", { active: _ctx.filters.status === 'progress' }]),
                    type: "button",
                    onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.setStatusFilter('progress')))
                  }, [
                    _cache[217] || (_cache[217] = _createTextVNode(" Em andamento ", -1)),
                    _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.statusCounts.progress), 1)
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["status-chip status-chip--done", { active: _ctx.filters.status === 'done' }]),
                    type: "button",
                    onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.setStatusFilter('done')))
                  }, [
                    _cache[218] || (_cache[218] = _createTextVNode(" Concluídas ", -1)),
                    _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.statusCounts.done), 1)
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["status-chip status-chip--late", { active: _ctx.filters.status === 'late' }]),
                    type: "button",
                    onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.setStatusFilter('late')))
                  }, [
                    _cache[219] || (_cache[219] = _createTextVNode(" Atrasadas ", -1)),
                    _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.statusCounts.late), 1)
                  ], 2),
                  (_ctx.statusCounts.nodate > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(["status-chip status-chip--nodate", { active: _ctx.filters.status === 'nodate' }]),
                        type: "button",
                        onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.setStatusFilter('nodate')))
                      }, [
                        _cache[220] || (_cache[220] = _createTextVNode(" Sem data ", -1)),
                        _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.statusCounts.nodate), 1)
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", {
                      class: "topbar-overall-fill",
                      style: _normalizeStyle({ width: _ctx.overallPct + '%' })
                    }, null, 4)
                  ]),
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.overallPct) + "%", 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
                  return _createElementVNode("div", {
                    key: i,
                    class: "gantt-skeleton-row"
                  }, [
                    _createVNode(_component_SkeletonBlock, {
                      width: "180px",
                      height: "13px"
                    }),
                    _createVNode(_component_SkeletonBlock, {
                      width: _ctx.skeletonBarWidth(i),
                      height: "20px",
                      radius: "4px"
                    }, null, 8, ["width"])
                  ])
                }), 64))
              ]))
            : (_ctx.filteredRows.length === 0 && _ctx.undatedRows.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.rows.length === 0 ? 'Nenhuma tarefa no planejamento.' : 'Nenhuma tarefa encontrada com os filtros atuais.'), 1),
                  (_ctx.accessMode === 'edit' && !_ctx.isAnalyst && _ctx.rows.length === 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "empty-add-btn",
                        type: "button",
                        onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.openCreatePanel && _ctx.openCreatePanel(...args)))
                      }, "+ Adicionar tarefa"))
                    : (_ctx.rows.length > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "empty-add-btn",
                          type: "button",
                          onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
                        }, "Limpar filtros"))
                      : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
          (_ctx.filteredRows.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createElementVNode("div", {
                  class: "gantt-labels",
                  ref: "labelsRef",
                  style: _normalizeStyle({ width: _ctx.labelsWidth + 'px', minWidth: _ctx.labelsWidth + 'px' })
                }, [
                  _createElementVNode("div", _hoisted_52, [
                    (_ctx.ganttEditMode)
                      ? (_openBlock(), _createElementBlock("label", {
                          key: 0,
                          class: "lbl-cb-label",
                          title: "Selecionar todas",
                          onClick: _cache[46] || (_cache[46] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createElementVNode("input", {
                            ref: "selectAllEl",
                            type: "checkbox",
                            class: "lbl-cb",
                            checked: _ctx.isAllSelected,
                            onChange: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)))
                          }, null, 40, _hoisted_53)
                        ]))
                      : _createCommentVNode("", true),
                    _cache[221] || (_cache[221] = _createElementVNode("span", { class: "label-header-title" }, "Tarefa", -1)),
                    _createElementVNode("div", _hoisted_54, [
                      (_ctx.accessMode === 'edit' && !_ctx.ganttEditMode && !_ctx.isAnalyst)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "label-hdr-btn",
                            type: "button",
                            title: "Adicionar tarefa",
                            onClick: _cache[47] || (_cache[47] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openCreatePanel && _ctx.openCreatePanel(...args)), ["stop"]))
                          }, "+"))
                        : _createCommentVNode("", true),
                      (_ctx.accessMode === 'edit' && !_ctx.ganttEditMode && !_ctx.isAnalyst)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "label-hdr-btn",
                            type: "button",
                            title: "Editar tarefas",
                            onClick: _cache[48] || (_cache[48] = _withModifiers(($event: any) => (_ctx.ganttEditMode = true), ["stop"]))
                          }, "Editar"))
                        : _createCommentVNode("", true)
                    ]),
                    (!_ctx.ganttEditMode)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_55, "%"))
                      : _createCommentVNode("", true)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRows, (row) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'lbl-' + row.id,
                      class: _normalizeClass(["label-row", {
            selected: _ctx.selectedTaskId === row.id && _ctx.selectedGanttIds.size <= 1,
            'label-row--checked': _ctx.ganttEditMode && _ctx.selectedGanttIds.has(row.id),
            'label-row--multi': !_ctx.ganttEditMode && _ctx.selectedGanttIds.has(row.id)
          }]),
                      style: _normalizeStyle({ height: _ctx.rowHeightPx + 'px', borderLeftColor: (!_ctx.ganttEditMode && _ctx.selectedGanttIds.has(row.id)) ? (row.color || 'var(--accent)') : (row.groupId && _ctx.groupById.get(row.groupId) ? _ctx.groupById.get(row.groupId)!.color : 'transparent') }),
                      onClick: ($event: any) => (_ctx.handleRowClick(row.id))
                    }, [
                      (_ctx.ganttEditMode)
                        ? (_openBlock(), _createElementBlock("label", {
                            key: 0,
                            class: "lbl-cb-label",
                            onClick: _cache[49] || (_cache[49] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              class: "lbl-cb",
                              checked: _ctx.selectedGanttIds.has(row.id),
                              onChange: ($event: any) => (_ctx.toggleSelectRow(row.id))
                            }, null, 40, _hoisted_57)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: "label-name",
                        title: row.title
                      }, _toDisplayString(row.title), 9, _hoisted_58),
                      _createElementVNode("div", _hoisted_59, [
                        (row.groupId && _ctx.groupById.get(row.groupId))
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "group-badge",
                              style: _normalizeStyle({ background: _ctx.groupById.get(row.groupId)!.color + '22', color: _ctx.groupById.get(row.groupId)!.color })
                            }, _toDisplayString(_ctx.groupById.get(row.groupId)!.name), 5))
                          : (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.assigneeName(row.assigneeUsername)), 1))
                      ]),
                      (!_ctx.ganttEditMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("div", {
                                class: "label-progress-fill",
                                style: _normalizeStyle({ width: _ctx.latestProgressPct(row) + '%', background: row.color || 'var(--accent)' })
                              }, null, 4)
                            ]),
                            _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.latestProgressPct(row)) + "%", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 14, _hoisted_56))
                  }), 128))
                ], 4),
                _createElementVNode("div", {
                  class: "label-resize-handle",
                  onMousedown: _cache[50] || (_cache[50] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startLabelResize && _ctx.startLabelResize(...args)), ["stop"])),
                  onTouchstart: _cache[51] || (_cache[51] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startLabelResizeTouch && _ctx.startLabelResizeTouch(...args)), ["stop","prevent"]))
                }, null, 32),
                _createElementVNode("div", {
                  class: _normalizeClass(["gantt-scroll", { 'gantt-scroll--hidden': _ctx.panelExpanded }]),
                  ref: "scrollRef",
                  onScrollPassive: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.syncLabelScroll && _ctx.syncLabelScroll(...args)))
                }, [
                  _createElementVNode("div", {
                    class: "timeline",
                    style: _normalizeStyle({ width: _ctx.totalWidthPx + 'px' })
                  }, [
                    _createElementVNode("div", {
                      class: "timeline-header",
                      style: _normalizeStyle({ width: _ctx.totalWidthPx + 'px' })
                    }, [
                      _createElementVNode("div", _hoisted_64, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerGroups, (grp) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: grp.key,
                            class: "header-group",
                            style: _normalizeStyle({ left: grp.leftPx + 'px', width: grp.widthPx + 'px' })
                          }, _toDisplayString(grp.label), 5))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerDays, (day) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'hd-' + day.key,
                            class: _normalizeClass(["header-day", { today: day.isToday, weekend: day.isWeekend, blocked: day.isBlocked }]),
                            style: _normalizeStyle({ width: _ctx.dayWidthPx + 'px' })
                          }, _toDisplayString(day.label), 7))
                        }), 128))
                      ])
                    ], 4),
                    _createElementVNode("div", {
                      class: "timeline-body",
                      style: _normalizeStyle({ width: _ctx.totalWidthPx + 'px', height: _ctx.timelineBodyHeightPx + 'px' })
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekendDays, (day) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'wknd-' + day.key,
                          class: "col-weekend",
                          style: _normalizeStyle({ left: day.leftPx + 'px', width: _ctx.dayWidthPx + 'px', height: _ctx.timelineBodyHeightPx + 'px' })
                        }, null, 4))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blockedDayCells, (day) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'blk-' + day.key,
                          class: "col-blocked",
                          style: _normalizeStyle({ left: day.leftPx + 'px', width: _ctx.dayWidthPx + 'px', height: _ctx.timelineBodyHeightPx + 'px' })
                        }, null, 4))
                      }), 128)),
                      (_ctx.todayLeftPx !== null)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "today-line",
                            style: _normalizeStyle({ left: _ctx.todayLeftPx + 'px', height: _ctx.timelineBodyHeightPx + 'px' })
                          }, [...(_cache[222] || (_cache[222] = [
                            _createElementVNode("span", { class: "today-label" }, "Hoje", -1)
                          ]))], 4))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRows, (row, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'track-' + row.id,
                          class: _normalizeClass(["track-row", { selected: _ctx.selectedTaskId === row.id && _ctx.selectedGanttIds.size <= 1, 'track-row--multi': !_ctx.ganttEditMode && _ctx.selectedGanttIds.has(row.id) }]),
                          style: _normalizeStyle({ top: index * _ctx.rowHeightPx + 'px', height: _ctx.rowHeightPx + 'px' })
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["bar", {
                  selected: _ctx.selectedTaskId === row.id && _ctx.selectedGanttIds.size <= 1,
                  'bar--multi': !_ctx.ganttEditMode && _ctx.selectedGanttIds.has(row.id),
                  dragging: _ctx.dragState !== null && _ctx.dragState.taskId === row.id
                }]),
                            style: _normalizeStyle(_ctx.computedBarStyle(row)),
                            onMousedown: _withModifiers(($event: any) => (_ctx.startDrag($event, row)), ["stop"]),
                            onClick: _withModifiers(($event: any) => (_ctx.handleRowClick(row.id)), ["stop"])
                          }, [
                            _createElementVNode("div", {
                              class: "bar-progress",
                              style: _normalizeStyle({ width: _ctx.latestProgressPct(row) + '%' })
                            }, null, 4),
                            (_ctx.todayBarPct(row) !== null && _ctx.todayBarPct(row)! > 0 && _ctx.todayBarPct(row)! < 100)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "bar-today-marker",
                                  style: _normalizeStyle({ left: _ctx.todayBarPct(row) + '%' })
                                }, null, 4))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.latestProgressPct(row)) + "%", 1)
                          ], 46, _hoisted_66),
                          (_ctx.overdueBarStyle(row).display !== 'none')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "bar bar-overdue",
                                style: _normalizeStyle(_ctx.overdueBarStyle(row)),
                                onClick: _withModifiers(($event: any) => (_ctx.handleRowClick(row.id)), ["stop"])
                              }, null, 12, _hoisted_68))
                            : _createCommentVNode("", true)
                        ], 6))
                      }), 128)),
                      (_openBlock(), _createElementBlock("svg", {
                        class: "deps-svg",
                        style: _normalizeStyle({ width: _ctx.totalWidthPx + 'px', height: _ctx.timelineBodyHeightPx + 'px' }),
                        overflow: "visible"
                      }, [
                        _cache[223] || (_cache[223] = _createElementVNode("defs", null, [
                          _createElementVNode("marker", {
                            id: "dep-arrow",
                            markerWidth: "7",
                            markerHeight: "7",
                            refX: "6",
                            refY: "3.5",
                            orient: "auto"
                          }, [
                            _createElementVNode("path", {
                              d: "M0,1 L0,6 L6,3.5 z",
                              fill: "rgba(120,120,130,0.7)"
                            })
                          ])
                        ], -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dependencyLines, (dep) => {
                          return (_openBlock(), _createElementBlock("path", {
                            key: dep.key,
                            d: dep.d,
                            fill: "none",
                            stroke: "rgba(120,120,130,0.55)",
                            "stroke-width": "1.5",
                            "stroke-dasharray": "5,3",
                            "marker-end": "url(#dep-arrow)"
                          }, null, 8, _hoisted_69))
                        }), 128))
                      ], 4))
                    ], 4)
                  ], 4)
                ], 34)
              ]))
            : _createCommentVNode("", true),
          (_ctx.undatedRows.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                _createElementVNode("button", {
                  class: "undated-header",
                  type: "button",
                  onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.undatedCollapsed = !_ctx.undatedCollapsed))
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass(["undated-chevron", { open: !_ctx.undatedCollapsed }]),
                    width: "12",
                    height: "12",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [...(_cache[224] || (_cache[224] = [
                    _createElementVNode("path", { d: "M9 18l6-6-6-6" }, null, -1)
                  ]))], 2)),
                  _cache[225] || (_cache[225] = _createElementVNode("span", { class: "undated-title" }, "Sem data definida", -1)),
                  _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.undatedRows.length), 1),
                  _cache[226] || (_cache[226] = _createElementVNode("span", { class: "undated-hint" }, "atividades aguardando agendamento", -1))
                ]),
                (!_ctx.undatedCollapsed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.undatedRows, (row) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'nd-' + row.id,
                          class: _normalizeClass(["undated-row", {
                selected: _ctx.selectedTaskId === row.id && _ctx.selectedGanttIds.size <= 1,
                'undated-row--multi': !_ctx.ganttEditMode && _ctx.selectedGanttIds.has(row.id),
                'undated-row--checked': _ctx.ganttEditMode && _ctx.selectedGanttIds.has(row.id)
              }]),
                          onClick: ($event: any) => (_ctx.handleRowClick(row.id))
                        }, [
                          (_ctx.ganttEditMode)
                            ? (_openBlock(), _createElementBlock("label", {
                                key: 0,
                                class: "lbl-cb-label",
                                onClick: _cache[54] || (_cache[54] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  class: "lbl-cb",
                                  checked: _ctx.selectedGanttIds.has(row.id),
                                  onChange: ($event: any) => (_ctx.toggleSelectRow(row.id))
                                }, null, 40, _hoisted_74)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", {
                            class: "undated-dot",
                            style: _normalizeStyle({ background: row.color || 'var(--accent)' })
                          }, null, 4),
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", {
                              class: "undated-name",
                              title: row.title
                            }, _toDisplayString(row.title), 9, _hoisted_76),
                            _createElementVNode("div", _hoisted_77, [
                              (row.groupId && _ctx.groupById.get(row.groupId))
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "group-badge",
                                    style: _normalizeStyle({ background: _ctx.groupById.get(row.groupId)!.color + '22', color: _ctx.groupById.get(row.groupId)!.color })
                                  }, _toDisplayString(_ctx.groupById.get(row.groupId)!.name), 5))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", null, _toDisplayString(_ctx.assigneeName(row.assigneeUsername)), 1)
                            ])
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(["status-pill", 'status-pill--' + _ctx.statusOf(row)])
                          }, _toDisplayString(_ctx.statusLabel(_ctx.statusOf(row))), 3),
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("div", _hoisted_79, [
                              _createElementVNode("div", {
                                class: "undated-progress-fill",
                                style: _normalizeStyle({ width: _ctx.latestProgressPct(row) + '%', background: row.color || 'var(--accent)' })
                              }, null, 4)
                            ]),
                            _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.latestProgressPct(row)) + "%", 1)
                          ]),
                          (_ctx.accessMode === 'edit' && !_ctx.isAnalyst && !_ctx.ganttEditMode)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "undated-schedule-btn",
                                type: "button",
                                title: "Definir data para esta atividade",
                                onClick: _withModifiers(($event: any) => (_ctx.openScheduleTask(row.id)), ["stop"])
                              }, [...(_cache[227] || (_cache[227] = [
                                _createElementVNode("svg", {
                                  width: "12",
                                  height: "12",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("rect", {
                                    x: "3",
                                    y: "4",
                                    width: "18",
                                    height: "18",
                                    rx: "2"
                                  }),
                                  _createElementVNode("path", { d: "M16 2v4M8 2v4M3 10h18" })
                                ], -1),
                                _createTextVNode(" Agendar ", -1)
                              ]))], 8, _hoisted_81))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_73))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.showPanel)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["edit-panel", { 'edit-panel--expanded': _ctx.panelExpanded }])
            }, [
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("span", {
                  class: "panel-title",
                  style: _normalizeStyle({ borderLeft: '3px solid ' + (_ctx.panelMode === 'create' ? 'var(--accent)' : (_ctx.selectedTask?.color || 'var(--accent)')) })
                }, _toDisplayString(_ctx.panelMode === 'create' ? 'Nova tarefa' : _ctx.selectedTask?.title), 5),
                _createElementVNode("button", {
                  class: "panel-expand-btn",
                  type: "button",
                  title: _ctx.panelExpanded ? 'Recolher' : 'Expandir',
                  onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.panelExpanded = !_ctx.panelExpanded))
                }, [
                  (_ctx.panelExpanded)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_84, "⇥"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_85, "⇤"))
                ], 8, _hoisted_83),
                _createElementVNode("button", {
                  class: "panel-close",
                  type: "button",
                  onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.closePanel && _ctx.closePanel(...args)))
                }, "✕")
              ]),
              _createElementVNode("div", _hoisted_86, [
                (_ctx.panelMode === 'view' && _ctx.selectedTask)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _cache[228] || (_cache[228] = _createElementVNode("span", null, "Responsavel", -1)),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.assigneeName(_ctx.selectedTask.assigneeUsername)), 1)
                        ]),
                        (_ctx.isUndated(_ctx.selectedTask))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_89, [...(_cache[229] || (_cache[229] = [
                              _createElementVNode("span", null, "Datas", -1),
                              _createElementVNode("strong", { class: "info-nodate" }, "Sem data definida", -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_90, [
                                _cache[230] || (_cache[230] = _createElementVNode("span", null, "Inicio", -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.selectedTask.plannedStart)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_91, [
                                _cache[231] || (_cache[231] = _createElementVNode("span", null, "Fim", -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.selectedTask.plannedEnd)), 1)
                              ])
                            ], 64)),
                        _createElementVNode("div", _hoisted_92, [
                          _cache[232] || (_cache[232] = _createElementVNode("span", null, "Status", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["status-pill", 'status-pill--' + _ctx.statusOf(_ctx.selectedTask)])
                          }, _toDisplayString(_ctx.statusLabel(_ctx.statusOf(_ctx.selectedTask))), 3)
                        ]),
                        _createElementVNode("div", _hoisted_93, [
                          _cache[233] || (_cache[233] = _createElementVNode("span", null, "Progresso", -1)),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.latestProgressPct(_ctx.selectedTask)) + "%", 1)
                        ]),
                        (_ctx.selectedTask.description)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                              _cache[234] || (_cache[234] = _createElementVNode("span", null, "Descricao", -1)),
                              _createElementVNode("p", _hoisted_95, _toDisplayString(_ctx.selectedTask.description), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.selectedTask.dependencyTaskIds && _ctx.selectedTask.dependencyTaskIds.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                              _cache[235] || (_cache[235] = _createElementVNode("span", null, "Pendências", -1)),
                              _createElementVNode("div", _hoisted_97, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTask.dependencyTaskIds, (depId) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: depId,
                                    class: "info-dep-tag"
                                  }, _toDisplayString(_ctx.tasks.find(t => t.id === depId)?.title || '?'), 1))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.selectedTask.infraestruturaNecessaria)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                              _cache[236] || (_cache[236] = _createElementVNode("span", null, "Infraestrutura necessária", -1)),
                              _createElementVNode("p", _hoisted_99, _toDisplayString(_ctx.selectedTask.infraestruturaNecessaria), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.selectedTask.requiredTools && _ctx.selectedTask.requiredTools.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                              _cache[237] || (_cache[237] = _createElementVNode("span", null, "Ferramentas necessárias", -1)),
                              _createElementVNode("div", _hoisted_101, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTask.requiredTools, (tool) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: tool.itemId,
                                    class: "info-tool-item"
                                  }, [
                                    _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.warehouseItems.find(t => t.id === tool.itemId)?.name || tool.itemId) + " × " + _toDisplayString(tool.quantity), 1),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(['info-tool-status', 'status-' + (_ctx.selectedTask.toolRequests?.find(r => r.itemId === tool.itemId)?.status || 'pendente')])
                                    }, _toDisplayString(_ctx.selectedTask.toolRequests?.find(r => r.itemId === tool.itemId)?.status || 'pendente'), 3)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.selectedTask.requiredMachinery && _ctx.selectedTask.requiredMachinery.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                              _cache[238] || (_cache[238] = _createElementVNode("span", null, "Maquinário necessário", -1)),
                              _createElementVNode("div", _hoisted_104, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTask.requiredMachinery, (mach) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: mach.machineryId,
                                    class: "info-machinery-item"
                                  }, [
                                    _createElementVNode("span", _hoisted_105, _toDisplayString(_ctx.heavyMachinery.find(m => m.id === mach.machineryId)?.title || mach.machineryId), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.selectedTask.teamIds && _ctx.selectedTask.teamIds.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                              _cache[239] || (_cache[239] = _createElementVNode("span", null, "Equipes", -1)),
                              _createElementVNode("div", _hoisted_107, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTask.teamIds, (teamId) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: teamId,
                                    class: "info-team-tag"
                                  }, _toDisplayString(_ctx.teams.find(t => t.id === teamId)?.name || '?'), 1))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_108, [
                        _createElementVNode("div", _hoisted_109, [
                          _createElementVNode("div", {
                            class: "panel-progress-fill",
                            style: _normalizeStyle({ width: _ctx.latestProgressPct(_ctx.selectedTask) + '%', background: _ctx.selectedTask.color || 'var(--accent)' })
                          }, null, 4)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_110, [
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          type: "button",
                          onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.openProgressMode && _ctx.openProgressMode(...args)))
                        }, "Atualizar progresso"),
                        (_ctx.accessMode === 'edit' && !_ctx.isAnalyst)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-ghost",
                              type: "button",
                              onClick: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.openEditMode && _ctx.openEditMode(...args)))
                            }, "Editar tarefa"))
                          : _createCommentVNode("", true),
                        (_ctx.accessMode === 'edit' && !_ctx.isAnalyst)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn-ghost",
                              type: "button",
                              onClick: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_ctx.openBlockedDaysModal && _ctx.openBlockedDaysModal(...args)))
                            }, "Dias não trabalhados"))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.selectedTask.progressUpdates && _ctx.selectedTask.progressUpdates.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                            _cache[243] || (_cache[243] = _createElementVNode("h5", { class: "progress-history-title" }, "Histórico de progresso", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...(_ctx.selectedTask.progressUpdates || [])].reverse(), (upd, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: upd.id || idx,
                                class: _normalizeClass(["progress-history-item", { 'progress-history-item--open': _ctx.isProgressExpanded(upd, idx) }])
                              }, [
                                _createElementVNode("div", _hoisted_112, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["progress-history-row", { 'progress-history-row--static': !_ctx.hasProgressDetails(upd) }]),
                                    onClick: ($event: any) => (_ctx.toggleProgressExpanded(upd, idx))
                                  }, [
                                    _createElementVNode("span", _hoisted_114, _toDisplayString(upd.progressPercent ?? 0) + "%", 1),
                                    _createElementVNode("span", _hoisted_115, _toDisplayString(_ctx.formatDate(upd.progressDate)), 1),
                                    _createElementVNode("span", _hoisted_116, [
                                      (upd.notes)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_117, [...(_cache[240] || (_cache[240] = [
                                            _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" }, null, -1)
                                          ]))]))
                                        : _createCommentVNode("", true),
                                      (upd.photoPath)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_118, [...(_cache[241] || (_cache[241] = [
                                            _createElementVNode("rect", {
                                              x: "3",
                                              y: "3",
                                              width: "18",
                                              height: "18",
                                              rx: "2"
                                            }, null, -1),
                                            _createElementVNode("circle", {
                                              cx: "8.5",
                                              cy: "8.5",
                                              r: "1.5"
                                            }, null, -1),
                                            _createElementVNode("path", { d: "M21 15l-5-5L5 21" }, null, -1)
                                          ]))]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.hasProgressDetails(upd))
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_119, [...(_cache[242] || (_cache[242] = [
                                          _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                                        ]))]))
                                      : _createCommentVNode("", true)
                                  ], 10, _hoisted_113),
                                  (_ctx.accessMode === 'edit' && upd.id && _ctx.onDeleteProgress && !_ctx.isAnalyst)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "progress-history-del",
                                        type: "button",
                                        title: "Remover",
                                        onClick: ($event: any) => (_ctx.deleteProgressUpdate(upd.id!))
                                      }, "✕", 8, _hoisted_120))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.isProgressExpanded(upd, idx) && _ctx.hasProgressDetails(upd))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                      (upd.notes)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_122, _toDisplayString(upd.notes), 1))
                                        : _createCommentVNode("", true),
                                      (upd.photoPath)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            src: _ctx.resolvePhotoPath(upd.photoPath),
                                            class: "progress-detail-photo",
                                            alt: "Foto da atualização",
                                            onClick: ($event: any) => (_ctx.lightboxSrc = _ctx.resolvePhotoPath(upd.photoPath))
                                          }, null, 8, _hoisted_123))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_124, [
                        _createElementVNode("h5", _hoisted_125, [
                          _cache[244] || (_cache[244] = _createTextVNode("Comentários ", -1)),
                          _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.taskComments.length), 1)
                        ]),
                        (_ctx.commentsLoading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_127, "Carregando…"))
                          : (_ctx.taskComments.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_128, "Nenhum comentário ainda."))
                            : (_openBlock(), _createElementBlock("div", _hoisted_129, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskComments, (c) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: c.id,
                                    class: "comment-item"
                                  }, [
                                    _createElementVNode("div", {
                                      class: "comment-avatar",
                                      style: _normalizeStyle({ background: _ctx.commentAvatarColor(c.authorName) })
                                    }, [
                                      (c.authorAvatar)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: _ctx.$resolveUrl(c.authorAvatar),
                                            class: "comment-avatar-img"
                                          }, null, 8, _hoisted_130))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_131, _toDisplayString(_ctx.commentInitials(c.authorName)), 1))
                                    ], 4),
                                    _createElementVNode("div", _hoisted_132, [
                                      _createElementVNode("div", _hoisted_133, [
                                        _createElementVNode("span", _hoisted_134, _toDisplayString(c.authorName), 1),
                                        _createElementVNode("span", _hoisted_135, _toDisplayString(_ctx.formatDate(c.createdAt.slice(0,10))), 1)
                                      ]),
                                      _createElementVNode("p", _hoisted_136, _toDisplayString(c.message), 1)
                                    ]),
                                    (c.authorUsername === _ctx.currentUsername || _ctx.isAdmin)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "comment-del",
                                          onClick: ($event: any) => (_ctx.deleteComment(c.id))
                                        }, "✕", 8, _hoisted_137))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])),
                        _createElementVNode("div", _hoisted_138, [
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.newComment) = $event)),
                            class: "comment-input",
                            placeholder: "Escrever comentário…",
                            rows: "2",
                            onKeydown: _cache[61] || (_cache[61] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.submitComment && _ctx.submitComment(...args)), ["ctrl"]), ["enter"]))
                          }, null, 544), [
                            [_vModelText, _ctx.newComment]
                          ]),
                          _createElementVNode("button", {
                            class: "btn btn-primary comment-send",
                            type: "button",
                            disabled: !_ctx.newComment.trim(),
                            onClick: _cache[62] || (_cache[62] = 
//@ts-ignore
(...args) => (_ctx.submitComment && _ctx.submitComment(...args)))
                          }, "Enviar", 8, _hoisted_139)
                        ])
                      ])
                    ], 64))
                  : (_ctx.panelMode === 'progress')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[250] || (_cache[250] = _createElementVNode("h4", { class: "panel-section-title" }, "Atualizar progresso", -1)),
                        _createElementVNode("div", _hoisted_140, [
                          _createElementVNode("div", _hoisted_141, [
                            _cache[245] || (_cache[245] = _createElementVNode("label", null, "Data", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.progressForm.date) = $event)),
                              type: "date"
                            }, null, 512), [
                              [_vModelText, _ctx.progressForm.date]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_142, [
                            _cache[246] || (_cache[246] = _createElementVNode("label", null, "Progresso (%)", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.progressForm.percent) = $event)),
                              type: "number",
                              min: "0",
                              max: "100"
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.progressForm.percent,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_143, [
                            _cache[247] || (_cache[247] = _createElementVNode("label", null, "Observacoes", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.progressForm.notes) = $event)),
                              type: "text",
                              placeholder: "Opcional"
                            }, null, 512), [
                              [_vModelText, _ctx.progressForm.notes]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_144, [
                            _cache[249] || (_cache[249] = _createElementVNode("label", null, "Foto (opcional)", -1)),
                            _createElementVNode("div", {
                              class: "photo-upload-area",
                              onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.progressPhotoInput?.click()))
                            }, [
                              (_ctx.progressPhotoPreview)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.progressPhotoPreview,
                                    class: "photo-preview"
                                  }, null, 8, _hoisted_145))
                                : (_openBlock(), _createElementBlock("span", _hoisted_146, [...(_cache[248] || (_cache[248] = [
                                    _createElementVNode("svg", {
                                      width: "20",
                                      height: "20",
                                      viewBox: "0 0 20 20",
                                      fill: "none"
                                    }, [
                                      _createElementVNode("rect", {
                                        x: "1",
                                        y: "4",
                                        width: "18",
                                        height: "13",
                                        rx: "2",
                                        stroke: "currentColor",
                                        "stroke-width": "1.4"
                                      }),
                                      _createElementVNode("circle", {
                                        cx: "10",
                                        cy: "10.5",
                                        r: "3",
                                        stroke: "currentColor",
                                        "stroke-width": "1.4"
                                      }),
                                      _createElementVNode("path", {
                                        d: "M7 4l1.5-2.5h3L13 4",
                                        stroke: "currentColor",
                                        "stroke-width": "1.4",
                                        "stroke-linecap": "round"
                                      })
                                    ], -1),
                                    _createTextVNode(" Adicionar foto ", -1)
                                  ]))])),
                              (_ctx.progressPhotoPreview)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    type: "button",
                                    class: "photo-remove",
                                    onClick: _cache[66] || (_cache[66] = _withModifiers(($event: any) => {_ctx.progressPhotoPreview = ''; _ctx.progressPhotoData = ''}, ["stop"]))
                                  }, "✕"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("input", {
                              ref: "progressPhotoInput",
                              type: "file",
                              accept: "image/*",
                              style: {"display":"none"},
                              onChange: _cache[68] || (_cache[68] = 
//@ts-ignore
(...args) => (_ctx.onProgressPhoto && _ctx.onProgressPhoto(...args)))
                            }, null, 544)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_147, [
                          _createElementVNode("button", {
                            class: "btn btn-primary",
                            type: "button",
                            onClick: _cache[69] || (_cache[69] = 
//@ts-ignore
(...args) => (_ctx.submitProgress && _ctx.submitProgress(...args)))
                          }, "Salvar"),
                          _createElementVNode("button", {
                            class: "btn btn-ghost",
                            type: "button",
                            onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.panelMode = 'view'))
                          }, "Cancelar")
                        ])
                      ], 64))
                    : (_ctx.panelMode === 'edit')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _cache[271] || (_cache[271] = _createElementVNode("h4", { class: "panel-section-title" }, "Editar tarefa", -1)),
                          _createElementVNode("div", _hoisted_148, [
                            _createElementVNode("div", _hoisted_149, [
                              _cache[251] || (_cache[251] = _createElementVNode("label", null, "Titulo", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.editForm.title) = $event)),
                                type: "text"
                              }, null, 512), [
                                [_vModelText, _ctx.editForm.title]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_150, [
                              _cache[252] || (_cache[252] = _createElementVNode("label", null, "Descricao", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.editForm.description) = $event)),
                                type: "text"
                              }, null, 512), [
                                [_vModelText, _ctx.editForm.description]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_151, [
                              _cache[253] || (_cache[253] = _createElementVNode("label", null, "Responsavel", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.editForm.assigneeUsername) = $event))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assignableUsers, (u) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: u.username,
                                    value: u.username
                                  }, _toDisplayString(u.name), 9, _hoisted_152))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.editForm.assigneeUsername]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_153, [
                              _cache[254] || (_cache[254] = _createElementVNode("label", null, "Duracao (dias)", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.editForm.durationDays) = $event)),
                                type: "number",
                                min: "1"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.editForm.durationDays,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_154, [
                              _cache[256] || (_cache[256] = _createElementVNode("label", null, "Cor", -1)),
                              _createElementVNode("div", _hoisted_155, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.editForm.color) = $event)),
                                  type: "color",
                                  class: "color-input",
                                  onChange: _cache[76] || (_cache[76] = ($event: any) => (_ctx.useColor(_ctx.editForm.color)))
                                }, null, 544), [
                                  [_vModelText, _ctx.editForm.color]
                                ]),
                                (_ctx.recentColors.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                                      _cache[255] || (_cache[255] = _createElementVNode("span", { class: "recent-colors-label" }, "Recentes", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentColors, (c) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: c,
                                          type: "button",
                                          class: "recent-color-swatch",
                                          style: _normalizeStyle({ background: c }),
                                          title: c,
                                          onClick: ($event: any) => (_ctx.editForm.color = c)
                                        }, null, 12, _hoisted_157))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_158, [
                              _cache[258] || (_cache[258] = _createElementVNode("label", null, "Data de inicio forcada", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.editForm.forcedStartDate) = $event)),
                                type: "date",
                                disabled: _ctx.editForm.noDate,
                                class: _normalizeClass({ 'input-disabled': _ctx.editForm.noDate })
                              }, null, 10, _hoisted_159), [
                                [_vModelText, _ctx.editForm.forcedStartDate]
                              ]),
                              _createElementVNode("label", _hoisted_160, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.editForm.noDate) = $event))
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.editForm.noDate]
                                ]),
                                _cache[257] || (_cache[257] = _createElementVNode("span", null, "Sem data definida", -1))
                              ]),
                              (_ctx.editForm.noDate)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_161, "A atividade ficará na lista \"Sem data definida\", fora da linha do tempo."))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_162, [
                              _cache[259] || (_cache[259] = _createElementVNode("label", null, "Dias de trabalho", -1)),
                              _createElementVNode("div", _hoisted_163, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdays, (wd) => {
                                  return (_openBlock(), _createElementBlock("label", {
                                    key: wd.value,
                                    class: "wd-check"
                                  }, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      value: wd.value,
                                      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.editForm.workDays) = $event))
                                    }, null, 8, _hoisted_164), [
                                      [_vModelCheckbox, _ctx.editForm.workDays]
                                    ]),
                                    _createTextVNode(" " + _toDisplayString(wd.label), 1)
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_165, [
                              _cache[261] || (_cache[261] = _createElementVNode("label", null, "Pendências", -1)),
                              _createElementVNode("div", _hoisted_166, [
                                (_ctx.editForm.dependencyTaskIds.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.dependencyTaskIds, (id) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: id,
                                          class: "dep-tag"
                                        }, [
                                          _createTextVNode(_toDisplayString(_ctx.tasks.find(t => t.id === id)?.title || id) + " ", 1),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "dep-tag-remove",
                                            onClick: ($event: any) => (_ctx.removeDep(id))
                                          }, "✕", 8, _hoisted_168)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_169, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.depSearch) = $event)),
                                    type: "text",
                                    class: "dep-search-input",
                                    placeholder: "Buscar tarefa...",
                                    autocomplete: "off",
                                    onFocus: _cache[81] || (_cache[81] = ($event: any) => (_ctx.depSearchOpen = true)),
                                    onBlur: _cache[82] || (_cache[82] = 
//@ts-ignore
(...args) => (_ctx.closeDepSearch && _ctx.closeDepSearch(...args)))
                                  }, null, 544), [
                                    [_vModelText, _ctx.depSearch]
                                  ]),
                                  (_ctx.depSearchOpen && _ctx.depSearchResults.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.depSearchResults, (t) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: t.id,
                                            class: "dep-search-item",
                                            onMousedown: _withModifiers(($event: any) => (_ctx.addDep(t.id)), ["prevent"])
                                          }, _toDisplayString(t.title), 41, _hoisted_171))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.depSearchOpen && _ctx.depSearchResults.length === 0 && _ctx.depSearch)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_172, [...(_cache[260] || (_cache[260] = [
                                        _createElementVNode("div", { class: "dep-search-empty" }, "Nenhuma tarefa encontrada", -1)
                                      ]))]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_173, [
                              _cache[263] || (_cache[263] = _createElementVNode("label", null, "Ferramentas necessárias", -1)),
                              _createElementVNode("div", _hoisted_174, [
                                (_ctx.editForm.requiredTools.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.requiredTools, (tool) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: tool.itemId,
                                          class: "tool-tag"
                                        }, [
                                          _createTextVNode(_toDisplayString(_ctx.warehouseItems.find(t => t.id === tool.itemId)?.name || tool.itemId) + " × " + _toDisplayString(tool.quantity) + " ", 1),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "tool-tag-remove",
                                            onClick: ($event: any) => (_ctx.removeTool(tool.itemId))
                                          }, "✕", 8, _hoisted_176)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_177, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.toolSearch) = $event)),
                                    type: "text",
                                    class: "tool-search-input",
                                    placeholder: "Buscar ferramenta...",
                                    autocomplete: "off",
                                    onFocus: _cache[84] || (_cache[84] = ($event: any) => (_ctx.toolSearchOpen = true)),
                                    onBlur: _cache[85] || (_cache[85] = 
//@ts-ignore
(...args) => (_ctx.closeToolSearch && _ctx.closeToolSearch(...args)))
                                  }, null, 544), [
                                    [_vModelText, _ctx.toolSearch]
                                  ]),
                                  (_ctx.toolSearchOpen && _ctx.toolSearchResults.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toolSearchResults, (item) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: item.id,
                                            class: "tool-search-item",
                                            onMousedown: _withModifiers(($event: any) => (_ctx.selectedToolForQuantity = item.id), ["prevent"])
                                          }, [
                                            _createElementVNode("span", null, _toDisplayString(item.name), 1),
                                            _createElementVNode("span", _hoisted_180, "(" + _toDisplayString(item.operationalUnits) + " disponível)", 1)
                                          ], 40, _hoisted_179))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.toolSearchOpen && _ctx.toolSearchResults.length === 0 && _ctx.toolSearch)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_181, [...(_cache[262] || (_cache[262] = [
                                        _createElementVNode("div", { class: "tool-search-empty" }, "Nenhuma ferramenta encontrada", -1)
                                      ]))]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.selectedToolForQuantity)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.toolQuantityInput) = $event)),
                                        type: "number",
                                        min: "1",
                                        class: "tool-quantity-input",
                                        placeholder: "Qtd",
                                        onKeyup: _cache[87] || (_cache[87] = _withKeys(($event: any) => (_ctx.addTool(_ctx.selectedToolForQuantity, _ctx.toolQuantityInput)), ["enter"]))
                                      }, null, 544), [
                                        [
                                          _vModelText,
                                          _ctx.toolQuantityInput,
                                          void 0,
                                          { number: true }
                                        ]
                                      ]),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "tool-add-btn",
                                        onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.addTool(_ctx.selectedToolForQuantity, _ctx.toolQuantityInput)))
                                      }, "Adicionar")
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_183, [
                              _cache[264] || (_cache[264] = _createElementVNode("label", null, "Infraestrutura necessária", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.editForm.infraestruturaNecessaria) = $event)),
                                placeholder: "Descreva a infraestrutura necessária para esta tarefa...",
                                rows: "3"
                              }, null, 512), [
                                [_vModelText, _ctx.editForm.infraestruturaNecessaria]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_184, [
                              _cache[266] || (_cache[266] = _createElementVNode("label", null, "Arquivos linkados", -1)),
                              _createElementVNode("div", _hoisted_185, [
                                (_ctx.editForm.linkedFileIds.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.linkedFileIds, (id) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: id,
                                          class: "file-tag"
                                        }, [
                                          _createTextVNode(_toDisplayString(_ctx.projectFiles.find(f => f.id === id)?.name || id) + " ", 1),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "file-tag-remove",
                                            onClick: ($event: any) => (_ctx.removeLinkedFile(id))
                                          }, "✕", 8, _hoisted_187)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_188, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.fileSearch) = $event)),
                                    type: "text",
                                    class: "file-search-input",
                                    placeholder: "Buscar arquivo...",
                                    autocomplete: "off",
                                    onFocus: _cache[91] || (_cache[91] = ($event: any) => (_ctx.fileSearchOpen = true)),
                                    onBlur: _cache[92] || (_cache[92] = 
//@ts-ignore
(...args) => (_ctx.closeFileSearch && _ctx.closeFileSearch(...args)))
                                  }, null, 544), [
                                    [_vModelText, _ctx.fileSearch]
                                  ]),
                                  (_ctx.fileSearchOpen && _ctx.fileSearchResults.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileSearchResults, (f) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: f.id,
                                            class: "file-search-item",
                                            onMousedown: _withModifiers(($event: any) => (_ctx.addLinkedFile(f.id)), ["prevent"])
                                          }, _toDisplayString(f.name), 41, _hoisted_190))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.fileSearchOpen && _ctx.fileSearchResults.length === 0 && _ctx.fileSearch)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_191, [...(_cache[265] || (_cache[265] = [
                                        _createElementVNode("div", { class: "file-search-empty" }, "Nenhum arquivo encontrado", -1)
                                      ]))]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_192, [
                              _cache[268] || (_cache[268] = _createElementVNode("label", null, "Equipes", -1)),
                              _createElementVNode("div", _hoisted_193, [
                                (_ctx.editForm.teamIds.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.teamIds, (id) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: id,
                                          class: "team-tag"
                                        }, [
                                          _createTextVNode(_toDisplayString(_ctx.teams.find(t => t.id === id)?.name || id) + " ", 1),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "team-tag-remove",
                                            onClick: ($event: any) => (_ctx.removeTeam(id))
                                          }, "✕", 8, _hoisted_195)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_196, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.teamSearch) = $event)),
                                    type: "text",
                                    class: "team-search-input",
                                    placeholder: "Buscar equipe...",
                                    autocomplete: "off",
                                    onFocus: _cache[94] || (_cache[94] = ($event: any) => (_ctx.teamSearchOpen = true)),
                                    onBlur: _cache[95] || (_cache[95] = 
//@ts-ignore
(...args) => (_ctx.closeTeamSearch && _ctx.closeTeamSearch(...args)))
                                  }, null, 544), [
                                    [_vModelText, _ctx.teamSearch]
                                  ]),
                                  (_ctx.teamSearchOpen && _ctx.teamSearchResults.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamSearchResults, (t) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: t.id,
                                            class: "team-search-item",
                                            onMousedown: _withModifiers(($event: any) => (_ctx.addTeam(t.id)), ["prevent"])
                                          }, _toDisplayString(t.name), 41, _hoisted_198))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.teamSearchOpen && _ctx.teamSearchResults.length === 0 && _ctx.teamSearch)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_199, [...(_cache[267] || (_cache[267] = [
                                        _createElementVNode("div", { class: "team-search-empty" }, "Nenhuma equipe encontrada", -1)
                                      ]))]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_200, [
                              _cache[270] || (_cache[270] = _createElementVNode("label", null, "Maquinário pesado necessário", -1)),
                              (_ctx.editForm.requiredMachinery.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.requiredMachinery, (item) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: item.machineryId,
                                        class: "machinery-tag"
                                      }, [
                                        _createTextVNode(_toDisplayString(_ctx.heavyMachinery.find(m => m.id === item.machineryId)?.title || item.machineryId) + " ", 1),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "machinery-tag-remove",
                                          onClick: ($event: any) => (_ctx.removeMachinery(item.machineryId))
                                        }, "✕", 8, _hoisted_202)
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_203, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.machinerySearch) = $event)),
                                  type: "text",
                                  class: "machinery-search-input",
                                  placeholder: "Buscar maquinário...",
                                  autocomplete: "off",
                                  onFocus: _cache[97] || (_cache[97] = ($event: any) => (_ctx.machinerySearchOpen = true)),
                                  onBlur: _cache[98] || (_cache[98] = 
//@ts-ignore
(...args) => (_ctx.closeMachinerySearch && _ctx.closeMachinerySearch(...args)))
                                }, null, 544), [
                                  [_vModelText, _ctx.machinerySearch]
                                ]),
                                (_ctx.machinerySearchOpen && _ctx.machinerySearchResults.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.machinerySearchResults, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: item.id,
                                          class: "machinery-search-item",
                                          onMousedown: _withModifiers(($event: any) => (_ctx.addMachinery(item.id, 1)), ["prevent"])
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(item.title), 1),
                                          _createElementVNode("span", _hoisted_206, "(" + _toDisplayString(item.categoryName) + ")", 1)
                                        ], 40, _hoisted_205))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.machinerySearchOpen && _ctx.machinerySearchResults.length === 0 && _ctx.machinerySearch)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_207, [...(_cache[269] || (_cache[269] = [
                                      _createElementVNode("div", { class: "machinery-search-empty" }, "Nenhum maquinário encontrado", -1)
                                    ]))]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          (_ctx.editError)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_208, _toDisplayString(_ctx.editError), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_209, [
                            _createElementVNode("button", {
                              class: "btn btn-primary",
                              type: "button",
                              onClick: _cache[99] || (_cache[99] = 
//@ts-ignore
(...args) => (_ctx.submitEdit && _ctx.submitEdit(...args)))
                            }, "Salvar"),
                            _createElementVNode("button", {
                              class: "btn btn-ghost",
                              type: "button",
                              onClick: _cache[100] || (_cache[100] = ($event: any) => (_ctx.panelMode = 'view'))
                            }, "Cancelar")
                          ])
                        ], 64))
                      : (_ctx.panelMode === 'create')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _cache[293] || (_cache[293] = _createElementVNode("h4", { class: "panel-section-title" }, "Nova tarefa", -1)),
                            _createElementVNode("div", _hoisted_210, [
                              _createElementVNode("div", _hoisted_211, [
                                _cache[272] || (_cache[272] = _createElementVNode("label", null, "Titulo", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => ((_ctx.editForm.title) = $event)),
                                  type: "text",
                                  placeholder: "Descrição da tarefa"
                                }, null, 512), [
                                  [_vModelText, _ctx.editForm.title]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_212, [
                                _cache[273] || (_cache[273] = _createElementVNode("label", null, "Descricao", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => ((_ctx.editForm.description) = $event)),
                                  type: "text",
                                  placeholder: "Observação (opcional)"
                                }, null, 512), [
                                  [_vModelText, _ctx.editForm.description]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_213, [
                                _cache[275] || (_cache[275] = _createElementVNode("label", null, "Responsavel", -1)),
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[103] || (_cache[103] = ($event: any) => ((_ctx.editForm.assigneeUsername) = $event))
                                }, [
                                  _cache[274] || (_cache[274] = _createElementVNode("option", { value: "" }, "Selecione responsavel", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assignableUsers, (u) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: u.username,
                                      value: u.username
                                    }, _toDisplayString(u.name), 9, _hoisted_214))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.editForm.assigneeUsername]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_215, [
                                _cache[276] || (_cache[276] = _createElementVNode("label", null, "Duracao (dias)", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[104] || (_cache[104] = ($event: any) => ((_ctx.editForm.durationDays) = $event)),
                                  type: "number",
                                  min: "1"
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    _ctx.editForm.durationDays,
                                    void 0,
                                    { number: true }
                                  ]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_216, [
                                _cache[278] || (_cache[278] = _createElementVNode("label", null, "Cor", -1)),
                                _createElementVNode("div", _hoisted_217, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[105] || (_cache[105] = ($event: any) => ((_ctx.editForm.color) = $event)),
                                    type: "color",
                                    class: "color-input",
                                    onChange: _cache[106] || (_cache[106] = ($event: any) => (_ctx.useColor(_ctx.editForm.color)))
                                  }, null, 544), [
                                    [_vModelText, _ctx.editForm.color]
                                  ]),
                                  (_ctx.recentColors.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                                        _cache[277] || (_cache[277] = _createElementVNode("span", { class: "recent-colors-label" }, "Recentes", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentColors, (c) => {
                                          return (_openBlock(), _createElementBlock("button", {
                                            key: c,
                                            type: "button",
                                            class: "recent-color-swatch",
                                            style: _normalizeStyle({ background: c }),
                                            title: c,
                                            onClick: ($event: any) => (_ctx.editForm.color = c)
                                          }, null, 12, _hoisted_219))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_220, [
                                _cache[280] || (_cache[280] = _createElementVNode("label", null, "Data de inicio forcada", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[107] || (_cache[107] = ($event: any) => ((_ctx.editForm.forcedStartDate) = $event)),
                                  type: "date",
                                  disabled: _ctx.editForm.noDate,
                                  class: _normalizeClass({ 'input-disabled': _ctx.editForm.noDate })
                                }, null, 10, _hoisted_221), [
                                  [_vModelText, _ctx.editForm.forcedStartDate]
                                ]),
                                _createElementVNode("label", _hoisted_222, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[108] || (_cache[108] = ($event: any) => ((_ctx.editForm.noDate) = $event))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.editForm.noDate]
                                  ]),
                                  _cache[279] || (_cache[279] = _createElementVNode("span", null, "Sem data definida", -1))
                                ]),
                                (_ctx.editForm.noDate)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_223, "A atividade ficará na lista \"Sem data definida\", fora da linha do tempo."))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_224, [
                                _cache[281] || (_cache[281] = _createElementVNode("label", null, "Dias de trabalho", -1)),
                                _createElementVNode("div", _hoisted_225, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdays, (wd) => {
                                    return (_openBlock(), _createElementBlock("label", {
                                      key: wd.value,
                                      class: "wd-check"
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        value: wd.value,
                                        "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event: any) => ((_ctx.editForm.workDays) = $event))
                                      }, null, 8, _hoisted_226), [
                                        [_vModelCheckbox, _ctx.editForm.workDays]
                                      ]),
                                      _createTextVNode(" " + _toDisplayString(wd.label), 1)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              (_ctx.tasks.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
                                    _cache[283] || (_cache[283] = _createElementVNode("label", null, "Pendências", -1)),
                                    _createElementVNode("div", _hoisted_228, [
                                      (_ctx.editForm.dependencyTaskIds.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_229, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.dependencyTaskIds, (id) => {
                                              return (_openBlock(), _createElementBlock("span", {
                                                key: id,
                                                class: "dep-tag"
                                              }, [
                                                _createTextVNode(_toDisplayString(_ctx.tasks.find(t => t.id === id)?.title || id) + " ", 1),
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "dep-tag-remove",
                                                  onClick: ($event: any) => (_ctx.removeDep(id))
                                                }, "✕", 8, _hoisted_230)
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_231, [
                                        _withDirectives(_createElementVNode("input", {
                                          "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event: any) => ((_ctx.depSearch) = $event)),
                                          type: "text",
                                          class: "dep-search-input",
                                          placeholder: "Buscar tarefa...",
                                          autocomplete: "off",
                                          onFocus: _cache[111] || (_cache[111] = ($event: any) => (_ctx.depSearchOpen = true)),
                                          onBlur: _cache[112] || (_cache[112] = 
//@ts-ignore
(...args) => (_ctx.closeDepSearch && _ctx.closeDepSearch(...args)))
                                        }, null, 544), [
                                          [_vModelText, _ctx.depSearch]
                                        ]),
                                        (_ctx.depSearchOpen && _ctx.depSearchResults.length > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_232, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.depSearchResults, (t) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: t.id,
                                                  class: "dep-search-item",
                                                  onMousedown: _withModifiers(($event: any) => (_ctx.addDep(t.id)), ["prevent"])
                                                }, _toDisplayString(t.title), 41, _hoisted_233))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.depSearchOpen && _ctx.depSearchResults.length === 0 && _ctx.depSearch)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_234, [...(_cache[282] || (_cache[282] = [
                                              _createElementVNode("div", { class: "dep-search-empty" }, "Nenhuma tarefa encontrada", -1)
                                            ]))]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_235, [
                                _cache[285] || (_cache[285] = _createElementVNode("label", null, "Ferramentas necessárias", -1)),
                                _createElementVNode("div", _hoisted_236, [
                                  (_ctx.editForm.requiredTools.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_237, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.requiredTools, (tool) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: tool.itemId,
                                            class: "tool-tag"
                                          }, [
                                            _createTextVNode(_toDisplayString(_ctx.warehouseItems.find(t => t.id === tool.itemId)?.name || tool.itemId) + " × " + _toDisplayString(tool.quantity) + " ", 1),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "tool-tag-remove",
                                              onClick: ($event: any) => (_ctx.removeTool(tool.itemId))
                                            }, "✕", 8, _hoisted_238)
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_239, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[113] || (_cache[113] = ($event: any) => ((_ctx.toolSearch) = $event)),
                                      type: "text",
                                      class: "tool-search-input",
                                      placeholder: "Buscar ferramenta...",
                                      autocomplete: "off",
                                      onFocus: _cache[114] || (_cache[114] = ($event: any) => (_ctx.toolSearchOpen = true)),
                                      onBlur: _cache[115] || (_cache[115] = 
//@ts-ignore
(...args) => (_ctx.closeToolSearch && _ctx.closeToolSearch(...args)))
                                    }, null, 544), [
                                      [_vModelText, _ctx.toolSearch]
                                    ]),
                                    (_ctx.toolSearchOpen && _ctx.toolSearchResults.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_240, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toolSearchResults, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: item.id,
                                              class: "tool-search-item",
                                              onMousedown: _withModifiers(($event: any) => (_ctx.selectedToolForQuantity = item.id), ["prevent"])
                                            }, [
                                              _createElementVNode("span", null, _toDisplayString(item.name), 1),
                                              _createElementVNode("span", _hoisted_242, "(" + _toDisplayString(item.operationalUnits) + " disponível)", 1)
                                            ], 40, _hoisted_241))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.toolSearchOpen && _ctx.toolSearchResults.length === 0 && _ctx.toolSearch)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_243, [...(_cache[284] || (_cache[284] = [
                                          _createElementVNode("div", { class: "tool-search-empty" }, "Nenhuma ferramenta encontrada", -1)
                                        ]))]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (_ctx.selectedToolForQuantity)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_244, [
                                        _withDirectives(_createElementVNode("input", {
                                          "onUpdate:modelValue": _cache[116] || (_cache[116] = ($event: any) => ((_ctx.toolQuantityInput) = $event)),
                                          type: "number",
                                          min: "1",
                                          class: "tool-quantity-input",
                                          placeholder: "Qtd",
                                          onKeyup: _cache[117] || (_cache[117] = _withKeys(($event: any) => (_ctx.addTool(_ctx.selectedToolForQuantity, _ctx.toolQuantityInput)), ["enter"]))
                                        }, null, 544), [
                                          [
                                            _vModelText,
                                            _ctx.toolQuantityInput,
                                            void 0,
                                            { number: true }
                                          ]
                                        ]),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "tool-add-btn",
                                          onClick: _cache[118] || (_cache[118] = ($event: any) => (_ctx.addTool(_ctx.selectedToolForQuantity, _ctx.toolQuantityInput)))
                                        }, "Adicionar")
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_245, [
                                _cache[286] || (_cache[286] = _createElementVNode("label", null, "Infraestrutura necessária", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[119] || (_cache[119] = ($event: any) => ((_ctx.editForm.infraestruturaNecessaria) = $event)),
                                  placeholder: "Descreva a infraestrutura necessária para esta tarefa...",
                                  rows: "3"
                                }, null, 512), [
                                  [_vModelText, _ctx.editForm.infraestruturaNecessaria]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_246, [
                                _cache[288] || (_cache[288] = _createElementVNode("label", null, "Arquivos linkados", -1)),
                                _createElementVNode("div", _hoisted_247, [
                                  (_ctx.editForm.linkedFileIds.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_248, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.linkedFileIds, (id) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: id,
                                            class: "file-tag"
                                          }, [
                                            _createTextVNode(_toDisplayString(_ctx.projectFiles.find(f => f.id === id)?.name || id) + " ", 1),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "file-tag-remove",
                                              onClick: ($event: any) => (_ctx.removeLinkedFile(id))
                                            }, "✕", 8, _hoisted_249)
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_250, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[120] || (_cache[120] = ($event: any) => ((_ctx.fileSearch) = $event)),
                                      type: "text",
                                      class: "file-search-input",
                                      placeholder: "Buscar arquivo...",
                                      autocomplete: "off",
                                      onFocus: _cache[121] || (_cache[121] = ($event: any) => (_ctx.fileSearchOpen = true)),
                                      onBlur: _cache[122] || (_cache[122] = 
//@ts-ignore
(...args) => (_ctx.closeFileSearch && _ctx.closeFileSearch(...args)))
                                    }, null, 544), [
                                      [_vModelText, _ctx.fileSearch]
                                    ]),
                                    (_ctx.fileSearchOpen && _ctx.fileSearchResults.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_251, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileSearchResults, (f) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: f.id,
                                              class: "file-search-item",
                                              onMousedown: _withModifiers(($event: any) => (_ctx.addLinkedFile(f.id)), ["prevent"])
                                            }, _toDisplayString(f.name), 41, _hoisted_252))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.fileSearchOpen && _ctx.fileSearchResults.length === 0 && _ctx.fileSearch)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_253, [...(_cache[287] || (_cache[287] = [
                                          _createElementVNode("div", { class: "file-search-empty" }, "Nenhum arquivo encontrado", -1)
                                        ]))]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_254, [
                                _cache[290] || (_cache[290] = _createElementVNode("label", null, "Equipes", -1)),
                                _createElementVNode("div", _hoisted_255, [
                                  (_ctx.editForm.teamIds.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_256, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.teamIds, (id) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: id,
                                            class: "team-tag"
                                          }, [
                                            _createTextVNode(_toDisplayString(_ctx.teams.find(t => t.id === id)?.name || id) + " ", 1),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "team-tag-remove",
                                              onClick: ($event: any) => (_ctx.removeTeam(id))
                                            }, "✕", 8, _hoisted_257)
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_258, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[123] || (_cache[123] = ($event: any) => ((_ctx.teamSearch) = $event)),
                                      type: "text",
                                      class: "team-search-input",
                                      placeholder: "Buscar equipe...",
                                      autocomplete: "off",
                                      onFocus: _cache[124] || (_cache[124] = ($event: any) => (_ctx.teamSearchOpen = true)),
                                      onBlur: _cache[125] || (_cache[125] = 
//@ts-ignore
(...args) => (_ctx.closeTeamSearch && _ctx.closeTeamSearch(...args)))
                                    }, null, 544), [
                                      [_vModelText, _ctx.teamSearch]
                                    ]),
                                    (_ctx.teamSearchOpen && _ctx.teamSearchResults.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_259, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamSearchResults, (t) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: t.id,
                                              class: "team-search-item",
                                              onMousedown: _withModifiers(($event: any) => (_ctx.addTeam(t.id)), ["prevent"])
                                            }, _toDisplayString(t.name), 41, _hoisted_260))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.teamSearchOpen && _ctx.teamSearchResults.length === 0 && _ctx.teamSearch)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_261, [...(_cache[289] || (_cache[289] = [
                                          _createElementVNode("div", { class: "team-search-empty" }, "Nenhuma equipe encontrada", -1)
                                        ]))]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_262, [
                                _cache[292] || (_cache[292] = _createElementVNode("label", null, "Maquinário pesado necessário", -1)),
                                (_ctx.editForm.requiredMachinery.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_263, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.requiredMachinery, (item) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: item.machineryId,
                                          class: "machinery-tag"
                                        }, [
                                          _createTextVNode(_toDisplayString(_ctx.heavyMachinery.find(m => m.id === item.machineryId)?.title || item.machineryId) + " ", 1),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "machinery-tag-remove",
                                            onClick: ($event: any) => (_ctx.removeMachinery(item.machineryId))
                                          }, "✕", 8, _hoisted_264)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_265, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[126] || (_cache[126] = ($event: any) => ((_ctx.machinerySearch) = $event)),
                                    type: "text",
                                    class: "machinery-search-input",
                                    placeholder: "Buscar maquinário...",
                                    autocomplete: "off",
                                    onFocus: _cache[127] || (_cache[127] = ($event: any) => (_ctx.machinerySearchOpen = true)),
                                    onBlur: _cache[128] || (_cache[128] = 
//@ts-ignore
(...args) => (_ctx.closeMachinerySearch && _ctx.closeMachinerySearch(...args)))
                                  }, null, 544), [
                                    [_vModelText, _ctx.machinerySearch]
                                  ]),
                                  (_ctx.machinerySearchOpen && _ctx.machinerySearchResults.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_266, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.machinerySearchResults, (item) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: item.id,
                                            class: "machinery-search-item",
                                            onMousedown: _withModifiers(($event: any) => (_ctx.addMachinery(item.id, 1)), ["prevent"])
                                          }, [
                                            _createElementVNode("span", null, _toDisplayString(item.title), 1),
                                            _createElementVNode("span", _hoisted_268, "(" + _toDisplayString(item.categoryName) + ")", 1)
                                          ], 40, _hoisted_267))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.machinerySearchOpen && _ctx.machinerySearchResults.length === 0 && _ctx.machinerySearch)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_269, [...(_cache[291] || (_cache[291] = [
                                        _createElementVNode("div", { class: "machinery-search-empty" }, "Nenhum maquinário encontrado", -1)
                                      ]))]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            (_ctx.editError)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_270, _toDisplayString(_ctx.editError), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_271, [
                              _createElementVNode("button", {
                                class: "btn btn-primary",
                                type: "button",
                                onClick: _cache[129] || (_cache[129] = 
//@ts-ignore
(...args) => (_ctx.submitCreate && _ctx.submitCreate(...args)))
                              }, "Criar tarefa"),
                              _createElementVNode("button", {
                                class: "btn btn-ghost",
                                type: "button",
                                onClick: _cache[130] || (_cache[130] = 
//@ts-ignore
(...args) => (_ctx.closePanel && _ctx.closePanel(...args)))
                              }, "Cancelar")
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
              ])
            ], 2))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.showImportModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "import-overlay",
            onClick: _cache[139] || (_cache[139] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeImportModal && _ctx.closeImportModal(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_272, [
              _createElementVNode("div", _hoisted_273, [
                _cache[294] || (_cache[294] = _createElementVNode("div", null, [
                  _createElementVNode("h3", null, "Importar tarefas do Excel"),
                  _createElementVNode("p", { class: "import-subtitle" }, "Envie uma planilha `.xlsx` e revise os itens antes de criar as tarefas no planejamento.")
                ], -1)),
                _createElementVNode("button", {
                  class: "panel-close",
                  type: "button",
                  onClick: _cache[131] || (_cache[131] = 
//@ts-ignore
(...args) => (_ctx.closeImportModal && _ctx.closeImportModal(...args)))
                }, "✕")
              ]),
              _createElementVNode("div", _hoisted_274, [
                _createElementVNode("input", {
                  ref: "importFileInput",
                  class: "hidden-file-input",
                  type: "file",
                  accept: ".xlsx,.xls",
                  onChange: _cache[132] || (_cache[132] = 
//@ts-ignore
(...args) => (_ctx.handleImportFile && _ctx.handleImportFile(...args)))
                }, null, 544),
                _createElementVNode("div", _hoisted_275, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "button",
                    onClick: _cache[133] || (_cache[133] = 
//@ts-ignore
(...args) => (_ctx.triggerImportFile && _ctx.triggerImportFile(...args)))
                  }, "Enviar arquivo Excel"),
                  _createElementVNode("button", {
                    class: "btn btn-ghost",
                    type: "button",
                    onClick: _cache[134] || (_cache[134] = 
//@ts-ignore
(...args) => (_ctx.downloadImportTemplate && _ctx.downloadImportTemplate(...args)))
                  }, "Baixar template")
                ]),
                _cache[295] || (_cache[295] = _createElementVNode("p", { class: "import-helper" }, "Colunas: A Titulo, B Descricao, C Duracao em Dias, D Data de inicio, E Cor.", -1)),
                _createElementVNode("button", {
                  class: "import-template-link",
                  type: "button",
                  onClick: _cache[135] || (_cache[135] = 
//@ts-ignore
(...args) => (_ctx.downloadImportTemplate && _ctx.downloadImportTemplate(...args)))
                }, "Baixar template de importacao")
              ]),
              (_ctx.importError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_276, _toDisplayString(_ctx.importError), 1))
                : _createCommentVNode("", true),
              (_ctx.importDrafts.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_277, [
                    _createElementVNode("div", _hoisted_278, [
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.importDrafts.length), 1),
                        _cache[296] || (_cache[296] = _createTextVNode(" tarefa(s) pronta(s) para revisar", -1))
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-ghost",
                        type: "button",
                        onClick: _cache[136] || (_cache[136] = ($event: any) => (_ctx.advancedImportMode = !_ctx.advancedImportMode))
                      }, _toDisplayString(_ctx.advancedImportMode ? 'Ocultar informações adicionais' : 'Modificar informações adicionais'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_279, [
                      _createElementVNode("table", _hoisted_280, [
                        _cache[307] || (_cache[307] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Titulo"),
                            _createElementVNode("th", null, "Descricao"),
                            _createElementVNode("th", null, "Dias"),
                            _createElementVNode("th", null, "Inicio"),
                            _createElementVNode("th", null, "Cor"),
                            _createElementVNode("th", null, "Responsavel"),
                            _createElementVNode("th")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importDrafts, (draft) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: draft.id
                            }, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", null, [
                                  (_ctx.advancedImportMode)
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 0,
                                        "onUpdate:modelValue": ($event: any) => ((draft.title) = $event),
                                        type: "text",
                                        class: "import-cell-input"
                                      }, null, 8, _hoisted_281)), [
                                        [_vModelText, draft.title]
                                      ])
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(draft.title), 1)
                                      ], 64))
                                ]),
                                _createElementVNode("td", null, [
                                  (_ctx.advancedImportMode)
                                    ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                        key: 0,
                                        "onUpdate:modelValue": ($event: any) => ((draft.description) = $event),
                                        class: "import-cell-textarea"
                                      }, null, 8, _hoisted_282)), [
                                        [_vModelText, draft.description]
                                      ])
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(draft.description || '-'), 1)
                                      ], 64))
                                ]),
                                _createElementVNode("td", null, [
                                  (_ctx.advancedImportMode)
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 0,
                                        "onUpdate:modelValue": ($event: any) => ((draft.durationDays) = $event),
                                        type: "number",
                                        min: "1",
                                        class: "import-cell-input import-cell-input--sm"
                                      }, null, 8, _hoisted_283)), [
                                        [
                                          _vModelText,
                                          draft.durationDays,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(draft.durationDays), 1)
                                      ], 64))
                                ]),
                                _createElementVNode("td", null, [
                                  (_ctx.advancedImportMode)
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 0,
                                        "onUpdate:modelValue": ($event: any) => ((draft.forcedStartDate) = $event),
                                        type: "date",
                                        class: "import-cell-input"
                                      }, null, 8, _hoisted_284)), [
                                        [_vModelText, draft.forcedStartDate]
                                      ])
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.formatDatePt(draft.forcedStartDate)), 1)
                                      ], 64))
                                ]),
                                _createElementVNode("td", null, [
                                  (_ctx.advancedImportMode)
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 0,
                                        "onUpdate:modelValue": ($event: any) => ((draft.color) = $event),
                                        type: "color",
                                        class: "color-input"
                                      }, null, 8, _hoisted_285)), [
                                        [_vModelText, draft.color]
                                      ])
                                    : (_openBlock(), _createElementBlock("span", _hoisted_286, [
                                        _createElementVNode("i", {
                                          style: _normalizeStyle({ background: draft.color })
                                        }, null, 4),
                                        _createTextVNode(_toDisplayString(draft.color), 1)
                                      ]))
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": ($event: any) => ((draft.assigneeUsername) = $event),
                                    class: "import-cell-input"
                                  }, [
                                    _cache[297] || (_cache[297] = _createElementVNode("option", { value: "" }, "Selecione", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assignableUsers, (user) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: user.username,
                                        value: user.username
                                      }, _toDisplayString(user.name), 9, _hoisted_288))
                                    }), 128))
                                  ], 8, _hoisted_287), [
                                    [_vModelSelect, draft.assigneeUsername]
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_289, [
                                  _createElementVNode("button", {
                                    class: "link link-inline",
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.removeImportedTask(draft.id))
                                  }, "Remover", 8, _hoisted_290)
                                ])
                              ]),
                              (_ctx.advancedImportMode)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_291, [
                                    _createElementVNode("td", _hoisted_292, [
                                      _createElementVNode("div", _hoisted_293, [
                                        _createElementVNode("div", _hoisted_294, [
                                          _cache[298] || (_cache[298] = _createElementVNode("label", null, "Dias de trabalho", -1)),
                                          _createElementVNode("div", _hoisted_295, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdays, (wd) => {
                                              return (_openBlock(), _createElementBlock("label", {
                                                key: `${draft.id}-${wd.value}`,
                                                class: "wd-check"
                                              }, [
                                                _createElementVNode("input", {
                                                  type: "checkbox",
                                                  checked: draft.workDays.includes(wd.value),
                                                  onChange: ($event: any) => (_ctx.toggleImportedWorkday(draft.id, wd.value))
                                                }, null, 40, _hoisted_296),
                                                _createTextVNode(" " + _toDisplayString(wd.label), 1)
                                              ]))
                                            }), 128))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_297, [
                                          _cache[299] || (_cache[299] = _createElementVNode("label", null, "Pendencia", -1)),
                                          _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": ($event: any) => ((draft.dependencyTaskIds) = $event),
                                            multiple: "",
                                            class: "import-multi-select"
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dependencyOptionsForImport(draft.id), (task) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: task.id,
                                                value: task.id
                                              }, _toDisplayString(task.title), 9, _hoisted_299))
                                            }), 128))
                                          ], 8, _hoisted_298), [
                                            [_vModelSelect, draft.dependencyTaskIds]
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_300, [
                                          _cache[300] || (_cache[300] = _createElementVNode("label", null, "Infraestrutura necessaria", -1)),
                                          _withDirectives(_createElementVNode("textarea", {
                                            "onUpdate:modelValue": ($event: any) => ((draft.infraestruturaNecessaria) = $event),
                                            class: "import-cell-textarea"
                                          }, null, 8, _hoisted_301), [
                                            [_vModelText, draft.infraestruturaNecessaria]
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_302, [
                                          _cache[301] || (_cache[301] = _createElementVNode("label", null, "Arquivos linkados", -1)),
                                          _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": ($event: any) => ((draft.linkedFileIds) = $event),
                                            multiple: "",
                                            class: "import-multi-select"
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectFiles, (file) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: file.id,
                                                value: file.id
                                              }, _toDisplayString(file.name), 9, _hoisted_304))
                                            }), 128))
                                          ], 8, _hoisted_303), [
                                            [_vModelSelect, draft.linkedFileIds]
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_305, [
                                          _cache[302] || (_cache[302] = _createElementVNode("label", null, "Equipes", -1)),
                                          _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": ($event: any) => ((draft.teamIds) = $event),
                                            multiple: "",
                                            class: "import-multi-select"
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: team.id,
                                                value: team.id
                                              }, _toDisplayString(team.name), 9, _hoisted_307))
                                            }), 128))
                                          ], 8, _hoisted_306), [
                                            [_vModelSelect, draft.teamIds]
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_308, [
                                          _cache[304] || (_cache[304] = _createElementVNode("label", null, "Ferramentas necessarias", -1)),
                                          _createElementVNode("div", _hoisted_309, [
                                            _withDirectives(_createElementVNode("select", {
                                              "onUpdate:modelValue": ($event: any) => ((draft.toolToAdd) = $event)
                                            }, [
                                              _cache[303] || (_cache[303] = _createElementVNode("option", { value: "" }, "Selecione", -1)),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableToolsForImport(draft), (item) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  key: item.id,
                                                  value: item.id
                                                }, _toDisplayString(item.name), 9, _hoisted_311))
                                              }), 128))
                                            ], 8, _hoisted_310), [
                                              [_vModelSelect, draft.toolToAdd]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": ($event: any) => ((draft.toolQuantity) = $event),
                                              type: "number",
                                              min: "1",
                                              class: "import-qty-input"
                                            }, null, 8, _hoisted_312), [
                                              [
                                                _vModelText,
                                                draft.toolQuantity,
                                                void 0,
                                                { number: true }
                                              ]
                                            ]),
                                            _createElementVNode("button", {
                                              class: "btn btn-ghost",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.addImportedTool(draft.id))
                                            }, "Adicionar", 8, _hoisted_313)
                                          ]),
                                          (draft.requiredTools.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_314, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(draft.requiredTools, (tool) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: `${draft.id}-${tool.itemId}`,
                                                    class: "import-tag-item"
                                                  }, [
                                                    _createElementVNode("span", null, _toDisplayString(_ctx.toolName(tool.itemId)), 1),
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((tool.quantity) = $event),
                                                      type: "number",
                                                      min: "1",
                                                      class: "import-qty-input"
                                                    }, null, 8, _hoisted_315), [
                                                      [
                                                        _vModelText,
                                                        tool.quantity,
                                                        void 0,
                                                        { number: true }
                                                      ]
                                                    ]),
                                                    _createElementVNode("button", {
                                                      class: "link link-inline",
                                                      type: "button",
                                                      onClick: ($event: any) => (_ctx.removeImportedTool(draft.id, tool.itemId))
                                                    }, "Remover", 8, _hoisted_316)
                                                  ]))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_317, [
                                          _cache[306] || (_cache[306] = _createElementVNode("label", null, "Maquinario pesado necessario", -1)),
                                          _createElementVNode("div", _hoisted_318, [
                                            _withDirectives(_createElementVNode("select", {
                                              "onUpdate:modelValue": ($event: any) => ((draft.machineryToAdd) = $event)
                                            }, [
                                              _cache[305] || (_cache[305] = _createElementVNode("option", { value: "" }, "Selecione", -1)),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableMachineryForImport(draft), (item) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  key: item.id,
                                                  value: item.id
                                                }, _toDisplayString(item.title), 9, _hoisted_320))
                                              }), 128))
                                            ], 8, _hoisted_319), [
                                              [_vModelSelect, draft.machineryToAdd]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": ($event: any) => ((draft.machineryQuantity) = $event),
                                              type: "number",
                                              min: "1",
                                              class: "import-qty-input"
                                            }, null, 8, _hoisted_321), [
                                              [
                                                _vModelText,
                                                draft.machineryQuantity,
                                                void 0,
                                                { number: true }
                                              ]
                                            ]),
                                            _createElementVNode("button", {
                                              class: "btn btn-ghost",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.addImportedMachinery(draft.id))
                                            }, "Adicionar", 8, _hoisted_322)
                                          ]),
                                          (draft.requiredMachinery.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_323, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(draft.requiredMachinery, (machine) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: `${draft.id}-${machine.machineryId}`,
                                                    class: "import-tag-item"
                                                  }, [
                                                    _createElementVNode("span", null, _toDisplayString(_ctx.machineryLabel(machine.machineryId)), 1),
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((machine.quantity) = $event),
                                                      type: "number",
                                                      min: "1",
                                                      class: "import-qty-input"
                                                    }, null, 8, _hoisted_324), [
                                                      [
                                                        _vModelText,
                                                        machine.quantity,
                                                        void 0,
                                                        { number: true }
                                                      ]
                                                    ]),
                                                    _createElementVNode("button", {
                                                      class: "link link-inline",
                                                      type: "button",
                                                      onClick: ($event: any) => (_ctx.removeImportedMachinery(draft.id, machine.machineryId))
                                                    }, "Remover", 8, _hoisted_325)
                                                  ]))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_326, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        type: "button",
                        disabled: _ctx.isImporting,
                        onClick: _cache[137] || (_cache[137] = 
//@ts-ignore
(...args) => (_ctx.confirmImportTasks && _ctx.confirmImportTasks(...args)))
                      }, _toDisplayString(_ctx.isImporting ? 'Importando...' : 'Importar para o planejamento'), 9, _hoisted_327),
                      _createElementVNode("button", {
                        class: "btn btn-ghost",
                        type: "button",
                        onClick: _cache[138] || (_cache[138] = 
//@ts-ignore
(...args) => (_ctx.closeImportModal && _ctx.closeImportModal(...args)))
                      }, "Cancelar")
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showBlockedDaysModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "modal-overlay",
            onClick: _cache[145] || (_cache[145] = _withModifiers(($event: any) => (_ctx.showBlockedDaysModal = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_328, [
              _createElementVNode("div", _hoisted_329, [
                _cache[308] || (_cache[308] = _createElementVNode("h3", null, "Dias não trabalhados", -1)),
                _createElementVNode("button", {
                  class: "panel-close",
                  type: "button",
                  onClick: _cache[140] || (_cache[140] = ($event: any) => (_ctx.showBlockedDaysModal = false))
                }, "✕")
              ]),
              _cache[309] || (_cache[309] = _createElementVNode("p", { class: "hint" }, "Dias sem trabalho (feriados, paradas programadas). Aparecem como faixas cinzas no cronograma.", -1)),
              _createElementVNode("div", _hoisted_330, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[141] || (_cache[141] = ($event: any) => ((_ctx.newBlockedDate) = $event)),
                  type: "date",
                  class: "filter-input"
                }, null, 512), [
                  [_vModelText, _ctx.newBlockedDate]
                ]),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  type: "button",
                  onClick: _cache[142] || (_cache[142] = 
//@ts-ignore
(...args) => (_ctx.addBlockedDate && _ctx.addBlockedDate(...args)))
                }, "Adicionar")
              ]),
              _createElementVNode("div", _hoisted_331, [
                (_ctx.localBlockedDates.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_332, "Nenhum dia bloqueado."))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localBlockedDates, (d) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: d,
                    class: "blocked-item"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(d)), 1),
                    _createElementVNode("button", {
                      class: "remove-btn",
                      type: "button",
                      onClick: ($event: any) => (_ctx.removeBlockedDate(d))
                    }, "✕", 8, _hoisted_333)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_334, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  type: "button",
                  onClick: _cache[143] || (_cache[143] = 
//@ts-ignore
(...args) => (_ctx.saveBlockedDatesLocal && _ctx.saveBlockedDatesLocal(...args)))
                }, "Salvar"),
                _createElementVNode("button", {
                  class: "btn btn-ghost",
                  type: "button",
                  onClick: _cache[144] || (_cache[144] = ($event: any) => (_ctx.showBlockedDaysModal = false))
                }, "Cancelar")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 32),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.lightboxSrc)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "lightbox-overlay",
            onClick: _cache[153] || (_cache[153] = ($event: any) => (_ctx.lightboxSrc = ''))
          }, [
            _createElementVNode("img", {
              src: _ctx.lightboxSrc,
              class: "lightbox-img",
              onClick: _cache[151] || (_cache[151] = _withModifiers(() => {}, ["stop"]))
            }, null, 8, _hoisted_335),
            _createElementVNode("button", {
              class: "lightbox-close",
              onClick: _cache[152] || (_cache[152] = ($event: any) => (_ctx.lightboxSrc = ''))
            }, "✕")
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showGanttReport)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "report-backdrop",
            onClick: _cache[163] || (_cache[163] = _withModifiers(($event: any) => (_ctx.showGanttReport = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_336, [
              _createElementVNode("div", _hoisted_337, [
                _createElementVNode("span", _hoisted_338, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_339, [...(_cache[310] || (_cache[310] = [
                    _createElementVNode("rect", {
                      x: "2",
                      y: "1.5",
                      width: "11",
                      height: "12",
                      rx: "1.5",
                      stroke: "currentColor",
                      "stroke-width": "1.4"
                    }, null, -1),
                    _createElementVNode("path", {
                      d: "M4.5 5h6M4.5 7.5h6M4.5 10h4",
                      stroke: "currentColor",
                      "stroke-width": "1.3",
                      "stroke-linecap": "round"
                    }, null, -1)
                  ]))])),
                  _cache[311] || (_cache[311] = _createTextVNode(" Relatório ", -1))
                ]),
                _createElementVNode("div", _hoisted_340, [
                  (!_ctx.reportOnlyNoDate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_341, [
                        _createElementVNode("button", {
                          class: "report-week-btn",
                          type: "button",
                          onClick: _cache[154] || (_cache[154] = 
//@ts-ignore
(...args) => (_ctx.reportPrevWeek && _ctx.reportPrevWeek(...args)))
                        }, "‹"),
                        _createElementVNode("span", _hoisted_342, _toDisplayString(_ctx.reportWeekLabel), 1),
                        _createElementVNode("button", {
                          class: "report-week-btn",
                          type: "button",
                          onClick: _cache[155] || (_cache[155] = 
//@ts-ignore
(...args) => (_ctx.reportNextWeek && _ctx.reportNextWeek(...args))),
                          disabled: !_ctx.reportHasCustomRange && _ctx.reportWeekOffset >= 0
                        }, "›", 8, _hoisted_343)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_344, _toDisplayString(_ctx.reportWeekLabel), 1)),
                  _createElementVNode("button", {
                    class: "report-modal-close",
                    type: "button",
                    onClick: _cache[156] || (_cache[156] = ($event: any) => (_ctx.showGanttReport = false))
                  }, "✕")
                ])
              ]),
              _createElementVNode("div", _hoisted_345, [
                (!_ctx.reportOnlyNoDate)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[312] || (_cache[312] = _createElementVNode("label", { class: "report-range-label" }, "De", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[157] || (_cache[157] = ($event: any) => ((_ctx.reportRange.from) = $event)),
                        type: "date",
                        class: "report-range-input"
                      }, null, 512), [
                        [_vModelText, _ctx.reportRange.from]
                      ]),
                      _cache[313] || (_cache[313] = _createElementVNode("label", { class: "report-range-label" }, "Até", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[158] || (_cache[158] = ($event: any) => ((_ctx.reportRange.to) = $event)),
                        type: "date",
                        class: "report-range-input"
                      }, null, 512), [
                        [_vModelText, _ctx.reportRange.to]
                      ]),
                      _createElementVNode("button", {
                        class: "report-range-btn",
                        type: "button",
                        disabled: !_ctx.reportRange.from || !_ctx.reportRange.to,
                        onClick: _cache[159] || (_cache[159] = 
//@ts-ignore
(...args) => (_ctx.applyReportRange && _ctx.applyReportRange(...args)))
                      }, "Aplicar", 8, _hoisted_346),
                      (_ctx.reportHasCustomRange)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "report-range-btn report-range-btn--ghost",
                            type: "button",
                            onClick: _cache[160] || (_cache[160] = 
//@ts-ignore
(...args) => (_ctx.clearReportRange && _ctx.clearReportRange(...args)))
                          }, "Semana"))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("span", _hoisted_347, "Somente atividades sem data definida")),
                _createElementVNode("button", {
                  class: _normalizeClass(["report-range-btn report-range-btn--nodate", { active: _ctx.reportOnlyNoDate }]),
                  type: "button",
                  onClick: _cache[161] || (_cache[161] = 
//@ts-ignore
(...args) => (_ctx.toggleReportNoDate && _ctx.toggleReportNoDate(...args)))
                }, [
                  _cache[314] || (_cache[314] = _createElementVNode("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("rect", {
                      x: "3",
                      y: "4",
                      width: "18",
                      height: "18",
                      rx: "2"
                    }),
                    _createElementVNode("path", { d: "M16 2v4M8 2v4M3 10h18M9 15.5h6" })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.reportOnlyNoDate ? 'Voltar ao período' : 'Somente sem data'), 1)
                ], 2)
              ]),
              (_ctx.reportLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_348, [...(_cache[315] || (_cache[315] = [
                    _createElementVNode("span", { class: "report-spinner" }, null, -1),
                    _createTextVNode(" Gerando relatório… ", -1)
                  ]))]))
                : (_ctx.reportError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_349, _toDisplayString(_ctx.reportError), 1))
                  : (_ctx.reportData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_350, [
                        _createElementVNode("div", _hoisted_351, [
                          _createElementVNode("span", _hoisted_352, _toDisplayString(_ctx.reportData._preview.summary.total) + " tarefas ativas", 1),
                          _createElementVNode("span", _hoisted_353, _toDisplayString(_ctx.reportData._preview.summary.completed) + " concluídas", 1),
                          (_ctx.reportData._preview.summary.overdue > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_354, _toDisplayString(_ctx.reportData._preview.summary.overdue) + " atrasadas", 1))
                            : _createCommentVNode("", true),
                          (_ctx.reportData._preview.summary.notStarted > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_355, _toDisplayString(_ctx.reportData._preview.summary.notStarted) + " não iniciadas", 1))
                            : _createCommentVNode("", true),
                          ((_ctx.reportData._preview.summary.noDate || 0) > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_356, _toDisplayString(_ctx.reportData._preview.summary.noDate) + " sem data", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("h4", _hoisted_357, _toDisplayString(_ctx.reportOnlyNoDate ? 'Atividades sem data' : (_ctx.reportHasCustomRange ? 'No período' : 'Esta semana')), 1),
                        (_ctx.reportData._preview.tasks.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_358, _toDisplayString(_ctx.reportOnlyNoDate ? 'Nenhuma atividade sem data.' : 'Nenhuma tarefa ativa neste período.'), 1))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportData._preview.tasks, (task) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: task.id,
                            class: "report-task-card"
                          }, [
                            _createElementVNode("div", _hoisted_359, [
                              _createElementVNode("div", _hoisted_360, [
                                _createElementVNode("span", _hoisted_361, _toDisplayString(task.title), 1),
                                (task.groupName)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_362, _toDisplayString(task.groupName), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_363, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["report-task-pct", _ctx.taskPctClass(task.progressPercent, task.noDate ? undefined : task.plannedEnd)])
                                }, _toDisplayString(task.progressPercent) + "% ", 3),
                                (task.noDate)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_364, "Sem data"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_365, _toDisplayString(_ctx.fmtDateShort(task.plannedStart)) + " → " + _toDisplayString(_ctx.fmtDateShort(task.plannedEnd)), 1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_366, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["report-progress-fill", _ctx.taskPctClass(task.progressPercent, task.noDate ? undefined : task.plannedEnd)]),
                                style: _normalizeStyle({ width: task.progressPercent + '%' })
                              }, null, 6)
                            ]),
                            (task.progressUpdates.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_367, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...task.progressUpdates].reverse(), (upd) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: upd.id,
                                      class: "report-update-row"
                                    }, [
                                      _createElementVNode("span", _hoisted_368, _toDisplayString(_ctx.fmtDateShort(upd.progressDate)) + " · " + _toDisplayString(upd.progressPercent) + "%", 1),
                                      (upd.notes)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_369, _toDisplayString(upd.notes), 1))
                                        : _createCommentVNode("", true),
                                      (upd.photoPath)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            src: _ctx.resolvePhotoPath(upd.photoPath || ''),
                                            class: "report-update-photo",
                                            onClick: ($event: any) => (_ctx.lightboxSrc = _ctx.resolvePhotoPath(upd.photoPath || ''))
                                          }, null, 8, _hoisted_370))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128)),
                        (_ctx.reportData._preview.upcoming.length > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[316] || (_cache[316] = _createElementVNode("h4", { class: "report-section-title" }, "Próximas a finalizar", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportData._preview.upcoming, (task) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: task.id,
                                  class: "report-upcoming-row"
                                }, [
                                  _createElementVNode("span", _hoisted_371, _toDisplayString(task.title), 1),
                                  _createElementVNode("span", _hoisted_372, "Previsto: " + _toDisplayString(_ctx.fmtDateShort(task.plannedEnd)), 1)
                                ]))
                              }), 128))
                            ], 64))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_373, [
                          _createElementVNode("button", {
                            class: "report-print-btn",
                            type: "button",
                            disabled: _ctx.printSaving,
                            onClick: _cache[162] || (_cache[162] = 
//@ts-ignore
(...args) => (_ctx.openPrintPreview && _ctx.openPrintPreview(...args)))
                          }, [
                            (!_ctx.printSaving)
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_375, [...(_cache[317] || (_cache[317] = [
                                  _createElementVNode("path", { d: "M2 5h10v6H2zM4 5V2h6v3M4 11v1h6v-1" }, null, -1),
                                  _createElementVNode("circle", {
                                    cx: "10",
                                    cy: "8",
                                    r: ".8",
                                    fill: "currentColor",
                                    stroke: "none"
                                  }, null, -1)
                                ]))]))
                              : _createCommentVNode("", true),
                            (_ctx.printSaving)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_376))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.printSaving ? 'Preparando…' : 'Visualizar Impressão / PDF'), 1)
                          ], 8, _hoisted_374)
                        ])
                      ]))
                    : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showPrintPreview && _ctx.printSubmission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_377, [
            _createVNode(_component_SubmissionPrintPreview, {
              submission: _ctx.printSubmission,
              onClose: _cache[164] || (_cache[164] = ($event: any) => (_ctx.showPrintPreview = false))
            }, null, 8, ["submission"])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showShareModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "share-backdrop",
            onClick: _cache[171] || (_cache[171] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeShareModal && _ctx.closeShareModal(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_378, [
              _createElementVNode("div", _hoisted_379, [
                _createElementVNode("span", _hoisted_380, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_381, [...(_cache[318] || (_cache[318] = [
                    _createElementVNode("circle", {
                      cx: "13",
                      cy: "3",
                      r: "2.2",
                      stroke: "currentColor",
                      "stroke-width": "1.4"
                    }, null, -1),
                    _createElementVNode("circle", {
                      cx: "13",
                      cy: "13",
                      r: "2.2",
                      stroke: "currentColor",
                      "stroke-width": "1.4"
                    }, null, -1),
                    _createElementVNode("circle", {
                      cx: "3",
                      cy: "8",
                      r: "2.2",
                      stroke: "currentColor",
                      "stroke-width": "1.4"
                    }, null, -1),
                    _createElementVNode("path", {
                      d: "M5.1 7l5.7-2.8M5.1 9l5.7 2.8",
                      stroke: "currentColor",
                      "stroke-width": "1.4",
                      "stroke-linecap": "round"
                    }, null, -1)
                  ]))])),
                  _cache[319] || (_cache[319] = _createTextVNode(" Compartilhar diagrama ", -1))
                ]),
                _createElementVNode("button", {
                  class: "share-modal-close",
                  type: "button",
                  onClick: _cache[165] || (_cache[165] = 
//@ts-ignore
(...args) => (_ctx.closeShareModal && _ctx.closeShareModal(...args)))
                }, "✕")
              ]),
              _createElementVNode("div", _hoisted_382, [
                _cache[322] || (_cache[322] = _createElementVNode("p", { class: "share-section-label" }, "Exportar", -1)),
                _createElementVNode("div", _hoisted_383, [
                  _createElementVNode("button", {
                    class: "share-action-btn",
                    type: "button",
                    onClick: _cache[166] || (_cache[166] = ($event: any) => {_ctx.exportGanttExcel(); _ctx.closeShareModal()})
                  }, [...(_cache[320] || (_cache[320] = [
                    _createElementVNode("span", { class: "share-action-icon share-action-icon--excel" }, [
                      _createElementVNode("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 16 16",
                        fill: "none"
                      }, [
                        _createElementVNode("rect", {
                          width: "16",
                          height: "16",
                          rx: "3",
                          fill: "#107C41"
                        }),
                        _createElementVNode("path", {
                          d: "M3 4h4v8H3zm5 0h5v8H8",
                          fill: "white",
                          opacity: ".15"
                        }),
                        _createElementVNode("path", {
                          d: "M4 6.5l1.5 3L7 6.5M9.5 6.5v3M9.5 9h2",
                          stroke: "white",
                          "stroke-width": "1.2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ])
                    ], -1),
                    _createElementVNode("div", { class: "share-action-text" }, [
                      _createElementVNode("span", { class: "share-action-label" }, "Exportar Excel"),
                      _createElementVNode("span", { class: "share-action-sub" }, "Gantt editável (.xlsx)")
                    ], -1)
                  ]))]),
                  _createElementVNode("button", {
                    class: "share-action-btn",
                    type: "button",
                    onClick: _cache[167] || (_cache[167] = ($event: any) => {_ctx.exportGantt(); _ctx.closeShareModal()})
                  }, [...(_cache[321] || (_cache[321] = [
                    _createElementVNode("span", { class: "share-action-icon share-action-icon--pdf" }, [
                      _createElementVNode("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 16 16",
                        fill: "none"
                      }, [
                        _createElementVNode("rect", {
                          width: "16",
                          height: "16",
                          rx: "3",
                          fill: "#C00000"
                        }),
                        _createElementVNode("path", {
                          d: "M4 3h5l3 3v7H4V3z",
                          fill: "white",
                          opacity: ".15"
                        }),
                        _createElementVNode("path", {
                          d: "M9 3v3h3M5.5 9h5M5.5 11h3",
                          stroke: "white",
                          "stroke-width": "1.2",
                          "stroke-linecap": "round"
                        })
                      ])
                    ], -1),
                    _createElementVNode("div", { class: "share-action-text" }, [
                      _createElementVNode("span", { class: "share-action-label" }, "Exportar PDF"),
                      _createElementVNode("span", { class: "share-action-sub" }, "Visualização para impressão")
                    ], -1)
                  ]))])
                ])
              ]),
              _cache[327] || (_cache[327] = _createElementVNode("div", { class: "share-divider" }, null, -1)),
              _createElementVNode("div", _hoisted_384, [
                _cache[325] || (_cache[325] = _createElementVNode("p", { class: "share-section-label" }, "Compartilhar visualização", -1)),
                _createElementVNode("div", _hoisted_385, [
                  _createElementVNode("button", {
                    class: "share-action-btn",
                    type: "button",
                    onClick: _cache[168] || (_cache[168] = ($event: any) => (_ctx.startShareLink('link')))
                  }, [...(_cache[323] || (_cache[323] = [
                    _createElementVNode("span", { class: "share-action-icon share-action-icon--link" }, [
                      _createElementVNode("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                        fill: "none"
                      }, [
                        _createElementVNode("path", {
                          d: "M7.5 10.5a4.5 4.5 0 0 0 6.36.13l1.5-1.5a4.5 4.5 0 0 0-6.36-6.36L7.87 3.9",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M10.5 7.5a4.5 4.5 0 0 0-6.36-.13l-1.5 1.5a4.5 4.5 0 0 0 6.36 6.36l1.12-1.12",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round"
                        })
                      ])
                    ], -1),
                    _createElementVNode("div", { class: "share-action-text" }, [
                      _createElementVNode("span", { class: "share-action-label" }, "Gerar link"),
                      _createElementVNode("span", { class: "share-action-sub" }, "Link de acesso temporário, sem login")
                    ], -1)
                  ]))]),
                  _createElementVNode("button", {
                    class: "share-action-btn",
                    type: "button",
                    onClick: _cache[169] || (_cache[169] = ($event: any) => (_ctx.startShareLink('email')))
                  }, [...(_cache[324] || (_cache[324] = [
                    _createElementVNode("span", { class: "share-action-icon share-action-icon--email" }, [
                      _createElementVNode("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                        fill: "none"
                      }, [
                        _createElementVNode("rect", {
                          x: "2",
                          y: "4",
                          width: "14",
                          height: "10",
                          rx: "2",
                          stroke: "currentColor",
                          "stroke-width": "1.5"
                        }),
                        _createElementVNode("path", {
                          d: "M2 6l7 5 7-5",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round"
                        })
                      ])
                    ], -1),
                    _createElementVNode("div", { class: "share-action-text" }, [
                      _createElementVNode("span", { class: "share-action-label" }, "Enviar por e-mail"),
                      _createElementVNode("span", { class: "share-action-sub" }, "Envia o link para um endereço")
                    ], -1)
                  ]))])
                ])
              ]),
              (_ctx.shareLinks.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_386, [
                    _createElementVNode("button", {
                      class: "share-manage-btn",
                      type: "button",
                      onClick: _cache[170] || (_cache[170] = ($event: any) => {_ctx.showManageModal = true; _ctx.showShareModal = false})
                    }, [
                      _cache[326] || (_cache[326] = _createElementVNode("svg", {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none"
                      }, [
                        _createElementVNode("circle", {
                          cx: "7",
                          cy: "7",
                          r: "5.5",
                          stroke: "currentColor",
                          "stroke-width": "1.3"
                        }),
                        _createElementVNode("path", {
                          d: "M7 4v3l2 1",
                          stroke: "currentColor",
                          "stroke-width": "1.3",
                          "stroke-linecap": "round"
                        })
                      ], -1)),
                      _createTextVNode(" Gerenciar acessos temporários (" + _toDisplayString(_ctx.shareLinks.filter(l => !l.revokedAt).length) + " ativo" + _toDisplayString(_ctx.shareLinks.filter(l => !l.revokedAt).length !== 1 ? 's' : '') + ") ", 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showDurationModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "share-backdrop",
            onClick: _cache[176] || (_cache[176] = _withModifiers(($event: any) => (_ctx.showDurationModal = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_387, [
              _createElementVNode("div", _hoisted_388, [
                _createElementVNode("span", _hoisted_389, _toDisplayString(_ctx.durationTarget === 'email' ? 'Enviar por e-mail' : 'Gerar link de acesso'), 1),
                _createElementVNode("button", {
                  class: "share-modal-close",
                  type: "button",
                  onClick: _cache[172] || (_cache[172] = ($event: any) => (_ctx.showDurationModal = false))
                }, "✕")
              ]),
              _createElementVNode("div", _hoisted_390, [
                (_ctx.durationTarget === 'email')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_391, [
                      _cache[328] || (_cache[328] = _createElementVNode("label", null, "E-mail do destinatário", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[173] || (_cache[173] = ($event: any) => ((_ctx.shareEmail) = $event)),
                        type: "email",
                        placeholder: "exemplo@email.com",
                        class: "share-input"
                      }, null, 512), [
                        [_vModelText, _ctx.shareEmail]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _cache[329] || (_cache[329] = _createElementVNode("p", { class: "share-section-label" }, "Validade do acesso", -1)),
                _createElementVNode("div", _hoisted_392, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.durationPresets, (p) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: p.value,
                      class: _normalizeClass(["duration-btn", { active: _ctx.selectedDuration === p.value }]),
                      type: "button",
                      onClick: ($event: any) => (_ctx.selectedDuration = p.value)
                    }, _toDisplayString(p.label), 11, _hoisted_393))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_394, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  type: "button",
                  disabled: _ctx.shareLoading || (_ctx.durationTarget === 'email' && !_ctx.shareEmail.trim()),
                  onClick: _cache[174] || (_cache[174] = 
//@ts-ignore
(...args) => (_ctx.confirmShare && _ctx.confirmShare(...args)))
                }, _toDisplayString(_ctx.shareLoading ? 'Gerando…' : (_ctx.durationTarget === 'email' ? 'Enviar' : 'Gerar link')), 9, _hoisted_395),
                _createElementVNode("button", {
                  class: "btn btn-ghost",
                  type: "button",
                  onClick: _cache[175] || (_cache[175] = ($event: any) => (_ctx.showDurationModal = false))
                }, "Cancelar")
              ]),
              (_ctx.shareError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_396, _toDisplayString(_ctx.shareError), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.generatedLink)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "share-backdrop",
            onClick: _cache[181] || (_cache[181] = _withModifiers(($event: any) => (_ctx.generatedLink = ''), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_397, [
              _createElementVNode("div", _hoisted_398, [
                _cache[330] || (_cache[330] = _createElementVNode("span", { class: "share-modal-title" }, "Link gerado com sucesso", -1)),
                _createElementVNode("button", {
                  class: "share-modal-close",
                  type: "button",
                  onClick: _cache[177] || (_cache[177] = ($event: any) => (_ctx.generatedLink = ''))
                }, "✕")
              ]),
              _createElementVNode("div", _hoisted_399, [
                _cache[332] || (_cache[332] = _createElementVNode("p", { class: "share-section-label" }, "Copie e compartilhe este link", -1)),
                _createElementVNode("div", _hoisted_400, [
                  _createElementVNode("input", {
                    value: _ctx.generatedLink,
                    readonly: "",
                    class: "share-link-input",
                    onClick: _cache[178] || (_cache[178] = ($event: any) => (($event.target as HTMLInputElement).select()))
                  }, null, 8, _hoisted_401),
                  _createElementVNode("button", {
                    class: "share-copy-btn",
                    type: "button",
                    onClick: _cache[179] || (_cache[179] = ($event: any) => (_ctx.copyLink(_ctx.generatedLink)))
                  }, _toDisplayString(_ctx.linkCopied ? '✓ Copiado' : 'Copiar'), 1)
                ]),
                (_ctx.generatedExpiry)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_402, [
                      _cache[331] || (_cache[331] = _createElementVNode("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none"
                      }, [
                        _createElementVNode("circle", {
                          cx: "6",
                          cy: "6",
                          r: "5",
                          stroke: "currentColor",
                          "stroke-width": "1.2"
                        }),
                        _createElementVNode("path", {
                          d: "M6 3.5v2.5l1.5 1",
                          stroke: "currentColor",
                          "stroke-width": "1.2",
                          "stroke-linecap": "round"
                        })
                      ], -1)),
                      _createTextVNode(" Válido até " + _toDisplayString(_ctx.generatedExpiry), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_403, [
                _createElementVNode("button", {
                  class: "btn btn-ghost",
                  type: "button",
                  onClick: _cache[180] || (_cache[180] = ($event: any) => (_ctx.generatedLink = ''))
                }, "Fechar")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showManageModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "share-backdrop",
            onClick: _cache[184] || (_cache[184] = _withModifiers(($event: any) => (_ctx.showManageModal = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_404, [
              _createElementVNode("div", _hoisted_405, [
                _cache[333] || (_cache[333] = _createElementVNode("span", { class: "share-modal-title" }, "Acessos temporários", -1)),
                _createElementVNode("button", {
                  class: "share-modal-close",
                  type: "button",
                  onClick: _cache[182] || (_cache[182] = ($event: any) => (_ctx.showManageModal = false))
                }, "✕")
              ]),
              _createElementVNode("div", _hoisted_406, [
                (_ctx.shareLinks.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_407, "Nenhum acesso gerado ainda."))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shareLinks, (link) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: link.id,
                    class: _normalizeClass(["manage-item", { revoked: !!link.revokedAt, expired: _ctx.isExpired(link) && !link.revokedAt }])
                  }, [
                    _createElementVNode("div", _hoisted_408, [
                      _createElementVNode("div", _hoisted_409, [
                        (link.email)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_410, _toDisplayString(link.email), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_411, "Link")),
                        _createElementVNode("code", _hoisted_412, "…" + _toDisplayString(link.id.slice(-6)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_413, [
                        _createElementVNode("span", null, "Criado " + _toDisplayString(_ctx.formatDatePt(link.createdAt.slice(0,10))), 1),
                        (link.revokedAt)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_414, "Revogado"))
                          : (_ctx.isExpired(link))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_415, "Expirado"))
                            : (link.expiresAt)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_416, "Válido até " + _toDisplayString(_ctx.formatDatePt(link.expiresAt.slice(0,10))), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_417, "Sem expiração"))
                      ])
                    ]),
                    (!link.revokedAt)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_418, [
                          _createElementVNode("button", {
                            class: "manage-btn",
                            type: "button",
                            onClick: ($event: any) => (_ctx.copyLink(_ctx.buildShareUrl(link.id)))
                          }, _toDisplayString(_ctx.copiedHash === link.id ? '✓' : 'Copiar'), 9, _hoisted_419),
                          _createElementVNode("button", {
                            class: "manage-btn manage-btn--extend",
                            type: "button",
                            onClick: ($event: any) => (_ctx.startExtend(link))
                          }, "Extender", 8, _hoisted_420),
                          _createElementVNode("button", {
                            class: "manage-btn manage-btn--revoke",
                            type: "button",
                            onClick: ($event: any) => (_ctx.revokeLink(link.id))
                          }, "Encerrar", 8, _hoisted_421)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_422, [
                _createElementVNode("button", {
                  class: "btn btn-ghost",
                  type: "button",
                  onClick: _cache[183] || (_cache[183] = ($event: any) => (_ctx.showManageModal = false))
                }, "Fechar")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.extendingLink)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "share-backdrop",
            onClick: _cache[188] || (_cache[188] = _withModifiers(($event: any) => (_ctx.extendingLink = null), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_423, [
              _createElementVNode("div", _hoisted_424, [
                _cache[334] || (_cache[334] = _createElementVNode("span", { class: "share-modal-title" }, "Extender acesso", -1)),
                _createElementVNode("button", {
                  class: "share-modal-close",
                  type: "button",
                  onClick: _cache[185] || (_cache[185] = ($event: any) => (_ctx.extendingLink = null))
                }, "✕")
              ]),
              _createElementVNode("div", _hoisted_425, [
                _cache[335] || (_cache[335] = _createElementVNode("p", { class: "share-section-label" }, "Nova validade", -1)),
                _createElementVNode("div", _hoisted_426, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.durationPresets, (p) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: p.value,
                      class: _normalizeClass(["duration-btn", { active: _ctx.extendDuration === p.value }]),
                      type: "button",
                      onClick: ($event: any) => (_ctx.extendDuration = p.value)
                    }, _toDisplayString(p.label), 11, _hoisted_427))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_428, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  type: "button",
                  onClick: _cache[186] || (_cache[186] = 
//@ts-ignore
(...args) => (_ctx.confirmExtend && _ctx.confirmExtend(...args)))
                }, "Confirmar"),
                _createElementVNode("button", {
                  class: "btn btn-ghost",
                  type: "button",
                  onClick: _cache[187] || (_cache[187] = ($event: any) => (_ctx.extendingLink = null))
                }, "Cancelar")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}